webpackJsonp([28],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(125);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import router from '../router';

exports.default = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$cinema_id = params.cinema_id,
      cinema_id = _params$cinema_id === undefined ? null : _params$cinema_id;

  var instance = _axios2.default.create({
    baseURL: _index.BASEURL
  });

  var JWT = window.localStorage.getItem("TOKEN") ? window.localStorage.getItem("TOKEN") : _index.TOKEN;
  if (JWT) {
    instance.defaults.headers.common["sales-authorization"] = JWT;
  }
  instance.defaults.headers.common["x-cinema-source"] = "0";

  instance.defaults.headers.common["x-cinema-destination"] = cinema_id ? cinema_id : "0";
  // instance.defaults.headers.common['Authorization'] = Vue.cookie.get('STRHTID')
  // instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  instance.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {
    // Do something with response error
    if (error && error.response && error.response.status == 403) {
      // vmVue.$router.push({
      //   path: "/access-denied"
      // });
      _vue2.default.toasted.show("You are not authorized");
    } else if (error && error.response && error.response.status == 401) {
      localStorage.clear();
      _vue2.default.cookie.delete("BRHSID");
      vmVue.$router.push({
        path: "/" // '/go-to-login'
      });
    } else {
      return _promise2.default.reject(error);
    }
  });
  return instance;
};

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(163);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(125);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(256);

var _extends3 = _interopRequireDefault(_extends2);

var _Api = __webpack_require__(255);

var _Api2 = _interopRequireDefault(_Api);

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(92);

var _lodash = __webpack_require__(160);

var _ApiHelper = __webpack_require__(604);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  VerifyMeritGirftCard: function VerifyMeritGirftCard(payload) {
    return (0, _Api2.default)().get("/api/pos/merit_gc/get_balance/" + payload.card_number);
  },
  PayByMeritGiftCard: function PayByMeritGiftCard(payload) {
    return (0, _Api2.default)().post("/api/pos/merit_gc/payment", payload);
  },
  CancelMeritGCTransaction: function CancelMeritGCTransaction(payload) {
    return (0, _Api2.default)().post("/api/pos/merit_gc/payment_cancel", payload);
  },
  AddEarnPoints: function AddEarnPoints(payload) {
    return (0, _Api2.default)().post("/earn_points", payload);
  },
  BurnPoints: function BurnPoints(payload) {
    return (0, _Api2.default)().post("/burn_points", payload);
  },
  getAllCinemaList: function getAllCinemaList() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return (0, _Api2.default)().post("/api/external/cinemas", payload);
  },
  GetCinemaList: function GetCinemaList(payload) {
    var cinema_id = payload.cinema_id && payload.cinema_id.toString().length > 0 ? payload.cinema_id : "";
    return (0, _Api2.default)().get("/api/admin/cinemas_list?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&cinema_id=" + cinema_id + "&searchKey=" + payload.searchKey + "&searchValue=" + payload.searchValue + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy);
  },
  GetCinemasMovieLicence: function GetCinemasMovieLicence() {
    return (0, _Api2.default)().get("/api/admin/cinema-list-movie-licence");
  },
  GetMacsLog: function GetMacsLog() {
    return (0, _Api2.default)().get("/api/admin/getMacsLogs");
  },
  getMailLogs: function getMailLogs() {
    return (0, _Api2.default)().get("/api/admin/autoemailreport-v2-logs");
  },
  GetGCAMLog: function GetGCAMLog() {
    return (0, _Api2.default)().get("/api/admin/getGCAMLogs");
  },
  GetCinemaSettingList: function GetCinemaSettingList() {
    return (0, _Api2.default)().get("/api/admin/cinemas_setting_list");
  },
  AddFeedbackForm: function AddFeedbackForm(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/addfeedbackform", payload);
  },
  GetAllForms: function GetAllForms(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/fetchforms?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy + "&searchValue=" + payload.searchValue);
  },
  GetFormData: function GetFormData(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/getformdata", payload);
  },
  GetInputFormData: function GetInputFormData(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/getinputformdata", payload);
  },
  InsertFormInput: function InsertFormInput(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/insertforminput", payload);
  },
  CustomerFormInput: function CustomerFormInput(payload) {
    return (0, _Api2.default)().post("/api/feedbackforms/customerforminput", payload);
  },
  InsertValue: function InsertValue(payload) {
    return (0, _Api2.default)().post("api/end/point", payload);
  },
  DeleteValue: function DeleteValue(payload) {
    return (0, _Api2.default)().post("api/end/point", payload);
  },
  UpdateValue: function UpdateValue(payload) {
    return (0, _Api2.default)().post("api/end/point", payload);
  },
  getCinemaList: function getCinemaList(payload) {
    return (0, _Api2.default)().get("ms_cinemas", payload);
  },
  getScreenList: function getScreenList(payload) {
    return (0, _Api2.default)().get("screens", payload);
  },
  addScreenLayout: function addScreenLayout(payload) {
    return (0, _Api2.default)().post("/screen_layouts", payload);
  },
  getSeatType: function getSeatType(payload) {
    return (0, _Api2.default)().get("ms_seat_reserve_types", payload);
  },
  getScreenSeatType: function getScreenSeatType(payload) {
    return (0, _Api2.default)().get("ms_seat_reserve_types", payload);
  },
  getMovieList: function getMovieList(payload) {
    return (0, _Api2.default)().get("movie/movielist", payload);
  },
  getSeatLayout: function getSeatLayout(payload) {
    return (0, _Api2.default)().get("/screen_layouts/" + payload.screenID, payload);
  },
  getDays: function getDays(payload) {
    return (0, _Api2.default)().get("ms_week_days", payload);
  },
  getCustomFields: function getCustomFields(payload) {
    return (0, _Api2.default)().post("/api/admin/getcustomfields", payload);
  },
  getCustomFieldValue: function getCustomFieldValue(payload) {
    return (0, _Api2.default)().post("/api/admin/getcustomfieldvalue", payload);
  },
  AddCustomFields: function AddCustomFields(payload) {
    return (0, _Api2.default)().post("/api/admin/addcustomfields", payload);
  },

  // AddSeo(payload) {
  //   return Api().post('/api/admin/seo', payload)
  // },
  // GetSeoList() {
  //   return Api().get('/api/admin/seo')
  // },
  // GetSeo(payload) {
  //   return Api().get(`/api/admin/seo?seo_meta_id=${payload.seo_meta_id}`)
  // },
  // EditSeo(payload) {
  //   return Api().put('/api/admin/seo', payload)
  // },
  EditGlobalPrivateOptions: function EditGlobalPrivateOptions(payload) {
    return (0, _Api2.default)().post("/global_options/update_private_global_options", payload);
  },
  GetGlobalPrivateOptions: function GetGlobalPrivateOptions(payload) {
    return (0, _Api2.default)().get("/global_options/private_global_options");
  },
  EditGlobalOptions: function EditGlobalOptions(payload) {
    return (0, _Api2.default)().put("/api/admin/globaloptions", payload);
  },
  GetPrivateGlobalOptions: function GetPrivateGlobalOptions(payload) {
    return (0, _Api2.default)().get("/api/admin/globaloptions_private");
  },
  EditPrivateGlobalOptions: function EditPrivateGlobalOptions(payload) {
    return (0, _Api2.default)().put("/api/admin/globaloptions_private", payload);
  },


  //cinema type
  AddCinemaType: function AddCinemaType(payload) {
    return (0, _Api2.default)().post("/api/admin/cinematype", payload);
  },
  GetCinemaTypesList: function GetCinemaTypesList(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/cinematype" + query);
  },
  GetCinemaTypeData: function GetCinemaTypeData(payload) {
    return (0, _Api2.default)().get("/api/admin/cinematype?cinema_type_id=" + payload.cinema_type_id);
  },
  EditCinemaType: function EditCinemaType(payload) {
    return (0, _Api2.default)().put("/api/admin/cinematype", payload);
  },


  //tier type
  GetTierTypeList: function GetTierTypeList() {
    return (0, _Api2.default)().get("/api/admin/tiertype");
  },
  AddTierType: function AddTierType(payload) {
    return (0, _Api2.default)().post("/api/admin/tiertype", payload);
  },
  GetTierTypeData: function GetTierTypeData(payload) {
    return (0, _Api2.default)().get("/api/admin/tiertype?tier_type_id=" + payload.tier_type_id);
  },
  EditTierType: function EditTierType(payload) {
    return (0, _Api2.default)().put("/api/admin/tiertype", payload);
  },
  GlobalRequest: function GlobalRequest(body) {
    switch (body.method) {
      case "GET":
        return (0, _Api2.default)().get("" + body.url);
        break;
      case "POST":
        return (0, _Api2.default)().post("" + body.url, body.payload);
        break;
      case "PUT":
        return (0, _Api2.default)().put("" + body.url, body.payload);
        break;
      case "DELETE":
        return (0, _Api2.default)().delete("" + body.url, body.payload);
        break;
      default:
        break;
    }
  },
  GlobalUploadImage: function GlobalUploadImage(payload, options) {
    // return Api().post('uploadimage',payload)
    var JWT = window.localStorage.getItem("TOKEN");
    var opts = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: JWT,
        "Access-Control-Allow-Origin": "*"
      }
    };
    if (options) {
      opts = (0, _extends3.default)({}, opts, options);
    }

    console.log(opts);
    // let JWT = window.localStorage.getItem("TOKEN");
    // const configHeaders = {
    //   headers: {
    //     "content-type": "multipart/form-data",
    //     Authorization: JWT,
    //     "Access-Control-Allow-Origin" :"*"
    //   }
    // };
    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_index.BASEURL + "/uploadimage", payload, opts).then(function (res) {
        return resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  SetupUploadImage: function SetupUploadImage(payload) {
    var AUTH_KEY = window.localStorage.getItem("AUTH_KEY");

    var configHeaders = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: AUTH_KEY
      }
    };

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_index.BASEURL + "/setupOrg/uploadimage", payload, configHeaders).then(function (res) {
        return resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  GlobalUploadVideo: function GlobalUploadVideo(payload, options) {
    if (!options) {
      options = {
        headers: {
          "content-type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*"
        }
      };
    }
    // const configHeaders = {
    //   headers: {
    //     "content-type": "multipart/form-data",
    //     "Access-Control-Allow-Origin" :"*"
    //   }
    // };

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_index.BASEURL + "/uploadvideo", payload, options).then(function (res) {
        return resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  GlobalUploadFile: function GlobalUploadFile(payload) {
    // return Api().post('uploadimage',payload)

    var configHeaders = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_index.BASEURL + "/uploadfile", payload, configHeaders).then(function (res) {
        return resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  GlobalUploadAllTypeFile: function GlobalUploadAllTypeFile(payload) {
    // return Api().post('uploadimage',payload)

    var configHeaders = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(_index.BASEURL + "/uploadfileContactUs", payload, configHeaders).then(function (res) {
        return resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  GetGlobalOptions: function GetGlobalOptions(payload) {
    if (payload) {
      var query = (0, _ApiHelper.createQueryString)(payload);
      return (0, _Api2.default)().get("/api/sales-analytics/global-options" + query);
    } else {
      return (0, _Api2.default)().get("/api/sales-analytics/global-options");
    }
  },
  GetHealthMeta: function GetHealthMeta() {
    return (0, _Api2.default)().get("/health-meta");
  },

  // GetActiveListByConditionalId(payload) {
  //   return Api().get(`/api/admin/tablelist/${payload.tableName}?activekey=${payload.activekey}&condition_col_name=${payload.condition_col_name}&condition_id=${payload.condition_id}`)
  // },
  GetActiveList: function GetActiveList(payload) {
    var query = "";
    var length = (0, _keys2.default)(payload).length;
    if (length > 0) {
      query = "?";
      (0, _keys2.default)(payload).map(function (x, index) {
        if (x !== "tableName") {
          query += index === length - 1 ? x + "=" + payload[x] : x + "=" + payload[x] + "&";
        }
      });
    }
    return (0, _Api2.default)().get("/api/admin/tablelist/" + payload.tableName + query);
  },


  // Ticket Type routes

  AddTicketTicketType: function AddTicketTicketType(payload) {
    return (0, _Api2.default)().post("/api/admin/ms_ticket_type", payload);
  },
  EditTicketTicketType: function EditTicketTicketType(payload) {
    return (0, _Api2.default)().put("/api/admin/ms_ticket_type", payload);
  },
  ViewTicketTicketType: function ViewTicketTicketType(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_ticket_type?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy + "&filter_is_active=" + payload.filter_is_active);
  },
  GetTicketTicketTypeById: function GetTicketTicketTypeById(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_ticket_type?id=" + payload.tt_id);
  },

  //Regions
  AddRegion: function AddRegion(payload) {
    return (0, _Api2.default)().post("/api/admin/ms_regions", payload);
  },
  EditRegion: function EditRegion(payload) {
    return (0, _Api2.default)().put("/api/admin/ms_regions", payload);
  },
  ListRegion: function ListRegion(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_regions?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy + "&searchValue=" + payload.searchValue);
  },
  GetRegionById: function GetRegionById(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_regions?id=" + payload.region_id);
  },


  /**
   * Denominations
   */
  AddDenomination: function AddDenomination(payload) {
    return (0, _Api2.default)().post("/api/admin/denominations", payload);
  },
  GetDenomination: function GetDenomination(country_id, payload) {
    // console.log('payload :', payload);
    return (0, _Api2.default)().get("/api/admin/denominations?country_id=" + country_id + "&limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&orderBy=" + payload.orderBy + "&columnName=" + payload.columnName);
  },
  GetDenominationById: function GetDenominationById(payload) {
    return (0, _Api2.default)().get("/api/admin/denominations/" + payload.denomination_id);
  },
  UpdateDenomination: function UpdateDenomination(payload) {
    return (0, _Api2.default)().put("/api/admin/denominations/" + payload.denomination_id, payload);
  },

  /**
   * Denominations End
   */
  /**
   *  Shift
   */
  GetUserShiftsByUserId: function GetUserShiftsByUserId(payload) {
    return (0, _Api2.default)().get("/api/admin/usershiftsbyuserid/" + payload.user_id);
  },
  GetRdrPdfReport: function GetRdrPdfReport(payload) {
    return (0, _Api2.default)().post("/api/admin/get-revenue-drop-pdf", payload);
  },
  GetRdrExcelReport: function GetRdrExcelReport(payload) {
    return (0, _Api2.default)().post("/api/admin/get-revenue-drop-excel", payload);
  },


  /**
   *  ShiftEnd
   */

  GetAllUserShifts: function GetAllUserShifts(payload) {
    return (0, _Api2.default)().get("/user_shifts", { params: payload });
  },
  AddUserShifts: function AddUserShifts(payload) {
    return (0, _Api2.default)().post("/user_shifts", payload);
  },
  GetUserShiftDetails: function GetUserShiftDetails(payload) {
    return (0, _Api2.default)().get("/user_shifts/" + payload.us_id);
  },
  GetAllUserShiftsDates: function GetAllUserShiftsDates() {
    return (0, _Api2.default)().get("/get_user_shifts_dates");
  },
  UpdateUserShifts: function UpdateUserShifts(payload) {
    return (0, _Api2.default)().put("/user_shifts", payload);
  },


  /**
   *  User Info
   */

  GetUserInfoById: function GetUserInfoById(payload) {
    return (0, _Api2.default)().get("/api/admin/userinfo/" + payload.user_id);
  },


  /**
   *  User Info End
   */

  // DELETE, May be extra
  GetData: function GetData(payload) {
    console.log("payload :", payload);
    // Delete
    // return Api().delete(`/api/users/${payload.ID}`)
    // POST
    // return Api().post('/api/users', payload)
    // return Api().put('/api/users', payload)
    // GET
    return (0, _Api2.default)().get("/api/users:", payload);
    // params
    // return Api().get(`/api/users/${payload.ID}`)
    // Query
    // return Api().get(`/api/users?${payload.ID}`)
  },
  AddUnitOfMeasurement: function AddUnitOfMeasurement(payload) {
    return (0, _Api2.default)().post("/ms_unit_of_measurement", payload);
  },
  editUnitOfMeasurementOperation: function editUnitOfMeasurementOperation(payload) {
    return (0, _Api2.default)().put("/ms_unit_of_measurement/" + payload.uom_id, payload);
  },
  GetUoMTList: function GetUoMTList(payload) {
    return (0, _Api2.default)().post("/get_conversion_to_list", payload);
  },
  GlobalRemoveFile: function GlobalRemoveFile(payload) {
    return (0, _Api2.default)().post("/api/admin/removereportfile", payload);
  },
  GenerateAggToken: function GenerateAggToken(payload) {
    return (0, _Api2.default)().get("/api/admin/generate_aggregator_token/" + payload.user_id);
  },
  RemoveDownloadedFile: function RemoveDownloadedFile(payload) {
    return (0, _Api2.default)().post("/api/admin/removeMultipleReportfile", payload);
  },
  generateTimLogs: function generateTimLogs(payload) {
    return (0, _Api2.default)().post("/api/admin/generateTimLogs", payload);
  },
  AddScreens: function AddScreens(payload) {
    return (0, _Api2.default)().post("/api/admin/screens", payload);
  },
  GetScreens: function GetScreens(payload) {
    // console.log('payload :', payload);
    return (0, _Api2.default)().get("/api/admin/screens?s_id=" + payload.s_id);
  },
  EditScreens: function EditScreens(payload) {
    return (0, _Api2.default)().put("/api/admin/screens", payload);
  },
  GetScreenTypes: function GetScreenTypes(payload) {
    if (payload && payload.hasOwnProperty("limit") && payload.hasOwnProperty("currentPage")) {
      return (0, _Api2.default)().get("/api/admin/screentypes?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy);
    } else {
      return (0, _Api2.default)().get("/api/admin/screentypes");
    }
  },
  GetSingleScreenType: function GetSingleScreenType(payload) {
    return (0, _Api2.default)().get("/api/admin/screentypes/" + payload.screen_type_id);
  },
  AddScreenTypes: function AddScreenTypes(payload) {
    return (0, _Api2.default)().post("/api/admin/screentypes", payload);
  },
  UpdateScreenTypes: function UpdateScreenTypes(payload) {
    return (0, _Api2.default)().put("/api/admin/screentypes/" + payload.screen_type_id, payload);
  },
  GetScreenSizeFormat: function GetScreenSizeFormat(payload) {
    if (payload && payload.hasOwnProperty("limit") && payload.hasOwnProperty("currentPage")) {
      return (0, _Api2.default)().get("/api/admin/screensizeformat?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy);
    } else {
      return (0, _Api2.default)().get("/api/admin/screensizeformat");
    }
  },
  GetSingleScreenSizeFormat: function GetSingleScreenSizeFormat(payload) {
    return (0, _Api2.default)().get("/api/admin/screensizeformat/" + payload.ssf_id);
  },
  AddScreenSizeFormat: function AddScreenSizeFormat(payload) {
    return (0, _Api2.default)().post("/api/admin/screensizeformat", payload);
  },
  UpdateScreenSizeFormat: function UpdateScreenSizeFormat(payload) {
    return (0, _Api2.default)().put("/api/admin/screensizeformat/" + payload.ssf_id, payload);
  },
  AddWeekends: function AddWeekends(payload) {
    return (0, _Api2.default)().post("/api/admin/weekends", payload);
  },
  GetWeekendsList: function GetWeekendsList(cinema_id) {
    return (0, _Api2.default)().get("/api/admin/weekends?cinema_id=" + cinema_id);
  },
  EditWeekends: function EditWeekends(payload) {
    return (0, _Api2.default)().put("/api/admin/weekends", payload);
  },


  // VERIFY DOCUMENTS API'S
  // BANK API'S
  getAllVerificationDocument: function getAllVerificationDocument(perPage, currentPage, columnName, orderby) {
    return (0, _Api2.default)().get("/api/admin/viewverificationdocuments?limit=" + perPage + "&currentPage=" + currentPage + "&columnName=" + columnName + "&orderBy=" + orderby);
  },
  getVerificationDocumentDetails: function getVerificationDocumentDetails(payload) {
    return (0, _Api2.default)().get("/api/admin/viewsingledocument/" + payload.vd_id);
  },
  addVerificationDocument: function addVerificationDocument(payload) {
    return (0, _Api2.default)().post("/api/admin/addverificationdocument", payload);
  },
  editVerificationDocument: function editVerificationDocument(payload) {
    return (0, _Api2.default)().put("/api/admin/updateverificationdocumnet/" + payload.vd_id, payload);
  },


  //Cinema Ticket Templates
  AddCinemaTicketTemplate: function AddCinemaTicketTemplate(payload) {
    return (0, _Api2.default)().post("/api/admin/cinematickettemplate", payload);
  },
  GetCinemaTicketTemplate: function GetCinemaTicketTemplate(body) {
    if (body && body.hasOwnProperty("limit") && body.hasOwnProperty("currentPage")) {
      var cinema_id = body.cinema_id && body.cinema_id.toString().length > 0 ? body.cinema_id : "";

      return (0, _Api2.default)().get("/api/admin/cinematickettemplate?limit=" + body.limit + "&currentPage=" + body.currentPage + "&cinema_id=" + cinema_id + "&columnName=" + body.columnName + "&orderBy=" + body.orderBy);
    } else {
      return (0, _Api2.default)().get("/api/admin/cinematickettemplate?tt_id=" + body.temp_id);
    }
  },
  EditCinemaTicketTemplate: function EditCinemaTicketTemplate(payload) {
    return (0, _Api2.default)().put("/api/admin/cinematickettemplate", payload);
  },


  //Ticket Templates
  GetTicketTemplate: function GetTicketTemplate(body) {
    if (body && body.hasOwnProperty("limit") && body.hasOwnProperty("currentPage") && !body.hasOwnProperty("columnName") && !body.hasOwnProperty("orderBy")) {
      return (0, _Api2.default)().get("/api/admin/tickettemplate?limit=" + body.limit + "&currentPage=" + body.currentPage);
    } else if (body && body.hasOwnProperty("limit") && body.hasOwnProperty("currentPage") && body.hasOwnProperty("columnName") && body.hasOwnProperty("orderBy")) {
      return (0, _Api2.default)().get("/api/admin/tickettemplate?limit=" + body.limit + "&currentPage=" + body.currentPage + "&columnName=" + body.columnName + "&orderBy=" + body.orderBy);
    } else {
      return (0, _Api2.default)().get("/api/admin/tickettemplate?t_id=" + body.temp_id + "&flag=" + body.flag);
    }
  },
  AddTicketTemplate: function AddTicketTemplate(payload) {
    return (0, _Api2.default)().post("/api/admin/tickettemplate", payload);
  },
  EditTicketTemplate: function EditTicketTemplate(payload) {
    return (0, _Api2.default)().put("/api/admin/tickettemplate", payload);
  },


  //Get Cinema Ticket Template for POS Ticket by CinemaID
  TicketTemplateByCinemaID: function TicketTemplateByCinemaID(payload) {
    return (0, _Api2.default)().get("/api/admin/ticket_template_by_cinemaID?cine_id=" + payload.cine_id);
  },
  ReleaseSeat: function ReleaseSeat(payload) {
    return (0, _Api2.default)().put("/api/admin/releaseseat", payload);
  },
  GetActiveUsersAccordingRolesList: function GetActiveUsersAccordingRolesList(payload) {
    return (0, _Api2.default)().post("/api/admin/getactiveusersaccordingroles", payload);
  },

  /**
   * Aggregators
   */
  AddAggregator: function AddAggregator(payload) {
    return (0, _Api2.default)().post("/api/admin/add-aggregator", payload);
  },
  UpdateAggregator: function UpdateAggregator(payload) {
    return (0, _Api2.default)().put("/api/admin/update-aggregator/" + payload.aggregator_id, payload);
  },

  /**
   * Aggregators END
   */
  /**
   * Shift Close
   */
  OnGetSingleShiftClose: function OnGetSingleShiftClose(payload) {
    return (0, _Api2.default)().get("/api/admin/get-shift-close-details/" + payload.shift_id);
  },
  OnShiftClose: function OnShiftClose(payload) {
    return (0, _Api2.default)().put("/api/admin/shift-close-update/" + payload.usl_id, payload);
  },
  OnUpdateShiftClose: function OnUpdateShiftClose(payload) {
    return (0, _Api2.default)().post("/api/admin/shift-close-update/" + payload.usl_id, payload);
  },
  updateTLStatus: function updateTLStatus(payload) {
    return (0, _Api2.default)().put("/api/admin/update-tl-close-shift", payload);
  },
  OnGetSingleViewShiftClose: function OnGetSingleViewShiftClose(payload) {
    return (0, _Api2.default)().get("/api/admin/get-shift-close-view-details/" + payload.shift_id);
  },

  /**
   * Shift Close
   */

  // Aggregator Movie Access Rights
  GetMovieBasedSchedule: function GetMovieBasedSchedule(payload) {
    return (0, _Api2.default)().post("/api/admin/get-movies-based-schedule?limit=" + payload.limit + "&currentPage=" + payload.currentPage, payload);
  },
  GetPosAggregatorUsers: function GetPosAggregatorUsers() {
    return (0, _Api2.default)().get("/api/admin/get-pos-aggegator-users");
  },
  SetAccessScheduleMapping: function SetAccessScheduleMapping(payload) {
    return (0, _Api2.default)().post("/api/admin/set-access-schedule-mapping", payload);
  },
  GetAllShowDates: function GetAllShowDates() {
    return (0, _Api2.default)().get("/api/admin/get-all-show-dates");
  },


  // Aggregator Movie Access Rights
  GetFnbBasedItems: function GetFnbBasedItems(payload) {
    return (0, _Api2.default)().post("/api/admin/get-fnb-based-items?limit=" + payload.limit + "&currentPage=" + payload.currentPage, payload);
  },
  GetFnBPosAggregatorUsers: function GetFnBPosAggregatorUsers() {
    return (0, _Api2.default)().get("/api/admin/get-fnb-based-items");
  },
  SetAccessFnBMapping: function SetAccessFnBMapping(payload) {
    return (0, _Api2.default)().post("/api/admin/set-access-fnb-mapping", payload);
  },
  GetAllToDates: function GetAllToDates() {
    return (0, _Api2.default)().get("/api/admin/get-all-fnb-to-dates");
  },
  GetDistributors: function GetDistributors() {
    return (0, _Api2.default)().get("/ms_distributors");
  },


  //user shift logs for audit logs
  getUserShiftLogsByDetail: function getUserShiftLogsByDetail(payload) {
    console.log("payload :", payload);
    return (0, _Api2.default)().post("/api/admin/posusershiftlogsdetails", payload);
  },
  getLogs: function getLogs(payload) {
    return (0, _Api2.default)().post("/api/admin/getlogdetails?limit=" + payload.perPage + "&currentPage=" + payload.currentPage, payload);
  },
  getTransactionsByDetail: function getTransactionsByDetail(payload) {
    console.log("payload :", payload);
    return (0, _Api2.default)().post("/api/admin/posusertransactions", payload);
  },
  getReservationsDetail: function getReservationsDetail(payload) {
    return (0, _Api2.default)().post("/api/admin/reservation-log", payload);
  },
  getReportBuilderDetail: function getReportBuilderDetail(payload) {
    var qs = (0, _ApiHelper.createQueryString)(payload);

    console.log({ qs: qs });
    console.log({ payload: payload });

    return (0, _Api2.default)().get("/api/admin/v2/dynamic-report/" + qs);
  },
  getAggregatorReport: function getAggregatorReport(payload) {
    var qs = (0, _ApiHelper.createQueryString)(payload);

    console.log({ qs: qs });
    console.log({ payload: payload });

    return (0, _Api2.default)().get("/api/admin/v2/aggregatorReport" + qs);
  },
  getAggregatorReportExcel: function getAggregatorReportExcel(payload) {
    return (0, _Api2.default)().post("/api/admin/v2/aggregatorReportExcel", payload);
  },
  getAggregatorReportPdf: function getAggregatorReportPdf(payload) {
    return (0, _Api2.default)().post("/api/admin/v2/aggregatorReportPdf", payload);
  },
  getReportBuilderFnBDetail: function getReportBuilderFnBDetail(payload) {
    var qs = (0, _ApiHelper.createQueryString)(payload);

    console.log({ qs: qs });
    console.log({ payload: payload });

    return (0, _Api2.default)().get("/api/admin/v2/dynamic-report-fnb/" + qs);
  },
  saveReportPreset: function saveReportPreset(payload) {
    return (0, _Api2.default)().post("/api/admin/v2/dynamic-report/save-preset", payload);
  },
  saveReportPresetWithChecker: function saveReportPresetWithChecker(payload) {
    return (0, _Api2.default)().post("/api/admin/v2/dynamic-report/save-preset-v2", payload);
  },
  saveReportPresetV3: function saveReportPresetV3(payload) {
    return (0, _Api2.default)().post("/api/admin/v2/dynamic-report/get-save-preset-v3", payload);
  },
  updateReportPreset: function updateReportPreset(rp_id, payload) {
    return (0, _Api2.default)().post("/api/admin/v2/dynamic-report/update-preset/" + rp_id, payload);
  },
  getCustomerDetails: function getCustomerDetails(payload) {
    return (0, _Api2.default)().post("/api/admin/getcustomerdetails?limit=" + payload.perPage + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy, payload);
  },
  getCustomerTransactions: function getCustomerTransactions(payload) {
    if (payload && payload.hasOwnProperty("limit") && payload.hasOwnProperty("currentPage")) {
      return (0, _Api2.default)().post("/api/admin/getcustomertransactiondetails?limit=" + payload.limit + "&currentPage=" + payload.currentPage, payload);
    } else {
      return (0, _Api2.default)().post("/api/admin/getcustomertransactiondetails", payload);
    }
  },
  getGuestCustomerTransactions: function getGuestCustomerTransactions(payload) {
    if (payload && payload.hasOwnProperty("limit") && payload.hasOwnProperty("currentPage")) {
      return (0, _Api2.default)().post("/api/admin/getGuestCustomerTransactiondetails?limit=" + payload.limit + "&currentPage=" + payload.currentPage, payload);
    } else {
      return (0, _Api2.default)().post("/api/admin/getcustomertransactiondetails", payload);
    }
  },
  GetActiveUsers: function GetActiveUsers(payload) {
    return (0, _Api2.default)().post("/active-list/users", payload);
  },
  GetActiveReportList: function GetActiveReportList(payload) {
    return (0, _Api2.default)().post("/active-list/report_list", payload);
  },
  AddAutoEmailReport: function AddAutoEmailReport(payload) {
    return (0, _Api2.default)().post("/api/admin/autoemailreport", payload);
  },
  AddAutoEmailReportV2: function AddAutoEmailReportV2(payload) {
    return (0, _Api2.default)().post("/api/admin/autoemailreport-v2", payload);
  },
  GetAutoEmailReport: function GetAutoEmailReport(payload) {
    return (0, _Api2.default)().get("/api/admin/autoemailreport", { params: payload });
  },
  GetAutoEmailReportV2: function GetAutoEmailReportV2(payload) {
    return (0, _Api2.default)().get("/api/admin/autoemailreport-v2", { params: payload });
  },
  GetSingleAutoEmailReport: function GetSingleAutoEmailReport(payload) {
    return (0, _Api2.default)().get("/api/admin/autoemailreport?aec_id=" + payload.aec_id);
  },
  EditAutoEmailReport: function EditAutoEmailReport(payload) {
    return (0, _Api2.default)().put("/api/admin/autoemailreport", payload);
  },


  //EmailTemplate
  AddEmailTemplate: function AddEmailTemplate(payload) {
    return (0, _Api2.default)().post("/api/admin/emailtemplate", payload);
  },
  GetEmailTemplate: function GetEmailTemplate(payload) {
    return (0, _Api2.default)().get("/api/admin/emailtemplate?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy);
  },
  GetSingleEmailTemplate: function GetSingleEmailTemplate(payload) {
    return (0, _Api2.default)().get("/api/admin/emailtemplate?et_id=" + payload.et_id);
  },
  EditEmailTemplate: function EditEmailTemplate(payload) {
    return (0, _Api2.default)().put("/api/admin/emailtemplate", payload);
  },


  //SMSTemplate
  AddSMSTemplate: function AddSMSTemplate(payload) {
    return (0, _Api2.default)().post("/api/admin/smstemplate", payload);
  },
  GetSMSTemplate: function GetSMSTemplate(payload) {
    return (0, _Api2.default)().get("/api/admin/smstemplate?limit=" + payload.limit + "&currentPage=" + payload.currentPage);
  },
  GetSingleSMSTemplate: function GetSingleSMSTemplate(payload) {
    return (0, _Api2.default)().get("/api/admin/smstemplate?sms_id=" + payload.sms_id);
  },
  EditSMSTemplate: function EditSMSTemplate(payload) {
    return (0, _Api2.default)().put("/api/admin/smstemplate", payload);
  },


  //Send EMail
  Sendemail: function Sendemail(payload) {
    return (0, _Api2.default)().post("/api/admin/sendemail", payload);
  },


  //Send SMS
  Sendsms: function Sendsms(payload) {
    return (0, _Api2.default)().post("/api/admin/sendsms", payload);
  },


  //ReceiptTemplate
  AddReceiptTemplate: function AddReceiptTemplate(payload) {
    return (0, _Api2.default)().post("/api/admin/receipttemplate", payload);
  },
  GetReceiptTemplate: function GetReceiptTemplate(payload) {
    if (payload && payload.hasOwnProperty("columnName") && payload.hasOwnProperty("orderBy")) {
      return (0, _Api2.default)().get("/api/admin/receipttemplate?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy);
    } else {
      return (0, _Api2.default)().get("/api/admin/receipttemplate?limit=" + payload.limit + "&currentPage=" + payload.currentPage);
    }
  },
  GetSingleReceiptTemplate: function GetSingleReceiptTemplate(payload) {
    return (0, _Api2.default)().get("/api/admin/GetSinglereceipttemplate?rtemp_id=" + payload.rtemp_id + "&flag=" + payload.flag);
  },
  UpdateReceiptTemplate: function UpdateReceiptTemplate(payload) {
    return (0, _Api2.default)().put("/api/admin/receipttemplate", payload);
  },


  //BannerService
  AddBanner: function AddBanner(payload) {
    return (0, _Api2.default)().post("/api/admin/addbanner", payload);
  },
  EditBanner: function EditBanner(payload) {
    return (0, _Api2.default)().put("/api/admin/editbanner", payload);
  },
  GetAllBanners: function GetAllBanners(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/getbanners" + query);
  },
  UpdateBannerStatus: function UpdateBannerStatus(payload) {
    // const query = createQueryString(payload);
    return (0, _Api2.default)().post("/api/admin/banner-status/" + payload.unique_id, payload);
  },
  GetMasterBanners: function GetMasterBanners(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/getmasterbanners" + query);
  },
  GetSingleBanner: function GetSingleBanner(payload) {
    return (0, _Api2.default)().get("/api/admin/getSinglebanners?b_id=" + payload.b_id);
  },
  UpdateBannerOrder: function UpdateBannerOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/editBannerOrder", payload);
  },
  GetBannerTypes: function GetBannerTypes() {
    return (0, _Api2.default)().get("/api/admin/bannertypes");
  },


  //Support Ticket Category
  AddCategory: function AddCategory(payload) {
    return (0, _Api2.default)().post("/api/admin/SupportTicketCategory", payload);
  },
  GetCategory: function GetCategory(payload) {
    if (payload && payload.hasOwnProperty("limit") && payload.hasOwnProperty("currentPage")) {
      return (0, _Api2.default)().get("/api/admin/SupportTicketCategory?limit=" + payload.limit + "&currentPage=" + payload.currentPage);
    } else {
      return (0, _Api2.default)().get("/api/admin/SupportTicketCategory?stc_id=" + payload.stc_id);
    }
  },
  UpdateCategory: function UpdateCategory(payload) {
    return (0, _Api2.default)().put("/api/admin/SupportTicketCategory", payload);
  },
  GenericSearch: function GenericSearch(payload) {
    return (0, _Api2.default)().post("/api/admin/generic/search", payload);
  },


  //Sound Format
  AddSoundFormat: function AddSoundFormat(payload) {
    return (0, _Api2.default)().post("/api/admin/soundformat", payload);
  },
  GetSoundFormatList: function GetSoundFormatList(payload) {
    return (0, _Api2.default)().get("/api/admin/soundformat?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy + "&searchValue=" + payload.searchValue + "&filter_is_active=" + payload.filter_is_active);
  },
  EditSoundFormat: function EditSoundFormat(payload) {
    return (0, _Api2.default)().put("/api/admin/soundformat", payload);
  },
  GetSoundFormat: function GetSoundFormat(payload) {
    return (0, _Api2.default)().post("/api/admin/getsoundformat/" + payload.sound_format_id);
  },
  GetCinemas: function GetCinemas() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    payload.cine_id = payload.cine_id && payload.cine_id.toString().length > 0 ? payload.cine_id : "";
    return (0, _Api2.default)().post("/api/sales-analytics/getcinemas", payload);
  },
  RejectToCinemaStockTransfer: function RejectToCinemaStockTransfer(tsl_id) {
    return (0, _Api2.default)().post("/transfer_stock/reject/" + tsl_id);
  },

  //Get Store Management
  GetStoreManagement: function GetStoreManagement(payload) {
    console.log("payload.cine_id:::::::::: :>> ", payload.cine_id);
    var cine_id = payload.cine_id && payload.cine_id.toString().length > 0 ? payload.cine_id : "";
    var sm_parent_id = payload.sm_parent_id && payload.sm_parent_id.toString().length > 0 ? payload.sm_parent_id : "";
    if (sm_parent_id.length == 0 && payload.sm_parent_id == 0) sm_parent_id = 0;
    console.log("cine_id :>> ", cine_id);
    return (0, _Api2.default)().get("/api/admin/getstoremanagement?cine_id=" + cine_id + "&sm_parent_id=" + sm_parent_id);
  },
  GetUsers: function GetUsers(payload) {
    var qs = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/getusers" + qs);
  },
  GetConcessionByCinema: function GetConcessionByCinema(payload) {
    var cine_id = payload.cine_id && payload.cine_id.toString().length > 0 ? payload.cine_id : "";
    console.log("cine_id :>> ", cine_id);
    return (0, _Api2.default)().get("/api/admin/getconcessionbycinema?cine_id=" + cine_id);
  },

  /**
   * Addons
   */
  CreateAddon: function CreateAddon(payload) {
    return (0, _Api2.default)().post("/api/admin/add_ons", payload);
  },
  UpdateAddons: function UpdateAddons(payload) {
    return (0, _Api2.default)().put("/api/admin/add_ons", payload);
  },
  GetSingleAddonDetails: function GetSingleAddonDetails(payload) {
    return (0, _Api2.default)().get("/api/admin/single_add_on/" + payload.add_on_id);
  },
  GetSingleAddonCharges: function GetSingleAddonCharges(payload) {
    return (0, _Api2.default)().get("/api/admin/single_add_on_charges/" + payload.add_on_id);
  },
  GetAllAddonsList: function GetAllAddonsList() {
    return (0, _Api2.default)().get("/api/admin/add_ons");
  },

  //get all images from gallery
  GetGalleryImages: function GetGalleryImages(payload) {
    return (0, _Api2.default)().post("/api/image-gallery", payload);
    // return Api().post(`/api/image-gallery?searchValue=${payload.searchValue}&menu=${payload.menu}&category=${payload.category}&limit=${payload.limit}&currentPage=${payload.currentPage}`)
    // ?limit=${payload.limit}&currentPage=${payload.currentPage
  },


  //booking source payment mapping
  AddBsPaymentMapping: function AddBsPaymentMapping(payload) {
    return (0, _Api2.default)().post("/api/admin/bs_payment_mapping", payload);
  },
  EditBsPaymentMapping: function EditBsPaymentMapping(payload) {
    return (0, _Api2.default)().put("/api/admin/bs_payment_mapping", payload);
  },
  UpdateImageDetails: function UpdateImageDetails(payload) {
    return (0, _Api2.default)().post("/api/image-gallery/" + payload.image_id, payload);
  },
  GetImageDetails: function GetImageDetails(image_id) {
    return (0, _Api2.default)().put("/api/image-gallery/" + image_id);
  },
  DisableImage: function DisableImage(image_id) {
    return (0, _Api2.default)().delete("/api/image-gallery/" + image_id);
  },
  getMultipleCinemasData: function getMultipleCinemasData(payload) {
    return (0, _Api2.default)().post("/api/admin/getMultipleCinemasDetails", payload);
  },

  //Delete Designation
  DeleteDesignationById: function DeleteDesignationById(payload) {
    return (0, _Api2.default)().delete("/ms_designations/" + payload.id);
  },
  updateRating: function updateRating(payload) {
    return (0, _Api2.default)().post("/api/admin/updateRating", payload);
  },
  GetComments: function GetComments(payload) {
    return (0, _Api2.default)().get("/api/admin/comments?limit=" + payload.limit + "&currentPage=" + payload.currentPage + "&columnName=" + payload.columnName + "&orderBy=" + payload.orderBy + "&searchValue=" + payload.searchValue);
  },
  UpdateComment: function UpdateComment(payload) {
    return (0, _Api2.default)().put("/api/admin/comments/" + payload.c_id, payload);
  },
  AddComment: function AddComment(payload) {
    return (0, _Api2.default)().post("/api/admin/comments", payload);
  },
  GetSingleComment: function GetSingleComment(payload) {
    return (0, _Api2.default)().get("/api/admin/comments/" + payload.c_id);
  },


  /* aspect Ratio */
  GetAllAspectRatios: function GetAllAspectRatios() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var qs = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/aspectratio/" + qs);
  },
  GetAspectRatio: function GetAspectRatio(aspect_ratio_id) {
    if (!aspect_ratio_id) return _promise2.default.reject();
    return (0, _Api2.default)().get("/api/admin/aspectratio/" + aspect_ratio_id);
  },
  AddAspectRatio: function AddAspectRatio(payload) {
    return (0, _Api2.default)().post("/api/admin/aspectratio/", payload);
  },
  UpdateAspectRatio: function UpdateAspectRatio(payload) {
    if (!payload.aspect_ratio_id) return _promise2.default.reject();
    return (0, _Api2.default)().put("/api/admin/aspectratio/" + payload.aspect_ratio_id, payload);
  },


  /* Movie Resolutions */
  GetAllMovieResolutions: function GetAllMovieResolutions() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var qs = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/movie-resolution/" + qs);
  },
  GetMovieResolution: function GetMovieResolution(resolution_id) {
    if (!resolution_id) return _promise2.default.reject();
    return (0, _Api2.default)().get("/api/admin/movie-resolution/" + resolution_id);
  },
  AddMovieResolution: function AddMovieResolution(payload) {
    return (0, _Api2.default)().post("/api/admin/movie-resolution/", payload);
  },
  UpdateMovieResolution: function UpdateMovieResolution(payload) {
    if (!payload.resolution_id) return _promise2.default.reject();
    return (0, _Api2.default)().put("/api/admin/movie-resolution/" + payload.resolution_id, payload);
  },


  /* Movie Experience Format */
  GetAllMovieExperienceFormats: function GetAllMovieExperienceFormats() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var qs = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/experience-format/" + qs);
  },
  GetMovieExperienceFormat: function GetMovieExperienceFormat(movie_experience_id) {
    if (!movie_experience_id) return _promise2.default.reject();
    return (0, _Api2.default)().get("/api/admin/experience-format/" + movie_experience_id);
  },
  AddMovieExperienceFormat: function AddMovieExperienceFormat(payload) {
    return (0, _Api2.default)().post("/api/admin/experience-format/", payload);
  },
  UpdateMovieExperienceFormat: function UpdateMovieExperienceFormat(payload) {
    if (!payload.movie_experience_id) return _promise2.default.reject();
    return (0, _Api2.default)().put("/api/admin/experience-format/" + payload.movie_experience_id, payload);
  },
  GetAllTranslations: function GetAllTranslations(payload) {
    return (0, _Api2.default)().get("/api/admin/translations?perPage=" + payload.perPage + "&currentPage=" + payload.currentPage + "&search=" + (payload.search ? payload.search : "") + "&columnName=" + (payload.columnName ? payload.columnName : "") + "&orderBy=" + (payload.orderBy ? payload.orderBy : "") + "&translation_id=" + (payload.translation_id ? payload.translation_id : ""));
  },
  UpdateTranslation: function UpdateTranslation(payload) {
    return (0, _Api2.default)().patch("/api/admin/edit-translation/" + payload.translation_id, payload);
  },
  GetPaymentModes: function GetPaymentModes() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/payment-modes/" + query);
  },
  GetWeekWisePdf: function GetWeekWisePdf(payload) {
    return (0, _Api2.default)().post("/api/admin/reports/v2/daily", payload);
  },
  GetOrgDetails: function GetOrgDetails() {
    return (0, _Api2.default)().get("/api/admin/getOrgDetails");
  },
  hotPickModule: function hotPickModule(payload) {
    return (0, _Api2.default)().post("/api/admin/hot-picks/" + payload.module_id);
  },
  getHotPickModules: function getHotPickModules() {
    return (0, _Api2.default)().get("/api/admin/hot-picks");
  },
  getAllLabels: function getAllLabels(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/ms_movie_labels" + query);
  },
  getAllReferralCode: function getAllReferralCode(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/marketing/referral_code" + query);
  },
  getAllFnbLabels: function getAllFnbLabels(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/ms_fnb_labels" + query);
  },
  AddLabel: function AddLabel(payload) {
    return (0, _Api2.default)().post("/api/admin/ms_movie_labels", payload);
  },
  AddCode: function AddCode(payload) {
    return (0, _Api2.default)().post("/api/marketing/referral_code", payload);
  },
  AddFnbLabel: function AddFnbLabel(payload) {
    return (0, _Api2.default)().post("/api/admin/ms_fnb_labels", payload);
  },
  EditLabel: function EditLabel(payload) {
    return (0, _Api2.default)().put("/api/admin/ms_movie_labels", payload);
  },
  EditReferralCode: function EditReferralCode(payload) {
    return (0, _Api2.default)().put("/api/marketing/referral_code", payload);
  },
  EditFnbLabel: function EditFnbLabel(payload) {
    return (0, _Api2.default)().put("/api/admin/ms_fnb_labels", payload);
  },
  GetSingleLabel: function GetSingleLabel(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_movie_labels/" + payload.label_id);
  },
  getReferralCode: function getReferralCode(payload) {
    return (0, _Api2.default)().get("/api/marketing/referral_code/" + payload.r_id);
  },
  GetSingleFnbLabel: function GetSingleFnbLabel(payload) {
    return (0, _Api2.default)().get("/api/admin/ms_fnb_labels/" + payload.label_id);
  },
  updateModuleFavouriteOrder: function updateModuleFavouriteOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/update-hot-picks-order", payload);
  },
  GetDefaultDistributorTax: function GetDefaultDistributorTax() {
    return (0, _Api2.default)().get("/api/admin/default_distributor_tax");
  },
  UpdateLanguageOrder: function UpdateLanguageOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/editLanguageOrder", payload);
  },
  GetMacsSettings: function GetMacsSettings() {
    return (0, _Api2.default)().get("/api/admin/macs/getAllMacsSettings");
  },

  // UpdateMacsSettings(payload) {
  //   return Api().post(`/api/admin/macs/updateMacs`, payload);
  // },
  GetAllDistributors: function GetAllDistributors(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/ms_distributors" + query);
  },
  GetMacsOrganisation: function GetMacsOrganisation() {
    return (0, _Api2.default)().get("/api/admin/getMacsOrganisation");
  },
  GetAllScreens: function GetAllScreens(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/getAllScreens" + query);
  },
  UpdateMacsSettings: function UpdateMacsSettings(payload) {
    return (0, _Api2.default)().put("/api/admin/updateMacsSettings", payload);
  },
  SaveOnDemandSetting: function SaveOnDemandSetting(payload) {
    return (0, _Api2.default)().post("/api/admin/updateOnDemandSetting", payload);
  },
  UpdateLabelsOrder: function UpdateLabelsOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/editLabelsOrder", payload);
  },
  UpdateFnbLabelsOrder: function UpdateFnbLabelsOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/editFnbLabelsOrder", payload);
  },
  UpdateMovieCategoryOrder: function UpdateMovieCategoryOrder(payload) {
    return (0, _Api2.default)().put("/api/admin/editMovieCategoryOrder", payload);
  },
  EnableDisableSchedule: function EnableDisableSchedule(payload) {
    return (0, _Api2.default)().post("/api/admin/disableSchedule/" + payload.md_id + "/" + payload.ss_id + "/" + payload.type);
  },
  ExtendSeatReleaseTime: function ExtendSeatReleaseTime(payload) {
    return (0, _Api2.default)().get("/api/pos/reset-timer/" + payload.reservation_id);
  },
  GetCinemaSettings: function GetCinemaSettings(payload) {
    return (0, _Api2.default)().get("/api/pos/cinemasetting/" + payload.cinema_id);
  },
  SendBookingMail: function SendBookingMail(payload) {
    return (0, _Api2.default)().post("/api/pos/booking-email", payload);
  },
  SendBookingSMS: function SendBookingSMS(payload) {
    return (0, _Api2.default)().post("/api/pos/booking-sms", payload);
  },
  getAllAddonsCharges: function getAllAddonsCharges(payload) {
    return (0, _Api2.default)().get("/api/admin/get-addons-rate-cards/" + payload.cinema_id);
  },
  UpdateAddonsCharge: function UpdateAddonsCharge(payload) {
    return (0, _Api2.default)().post("/api/admin/add-addons-rate-cards", payload);
  },
  TestPrint: function TestPrint(payload) {
    return (0, _Api2.default)().get("/api/pos/testprint/" + payload.cinema_id + "/" + payload.type);
  },
  GetAllHardwareLocations: function GetAllHardwareLocations(payload) {
    var qs = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/admin/hardware_locations" + qs);
  },
  AddHardwareLocation: function AddHardwareLocation(payload) {
    return (0, _Api2.default)().post("/api/admin/hardware_locations", payload);
  },
  UpdateHardwareLocation: function UpdateHardwareLocation(payload) {
    return (0, _Api2.default)().put("/api/admin/hardware_locations", payload);
  },
  getSingleHardwareLocation: function getSingleHardwareLocation(payload) {
    return (0, _Api2.default)().get("/api/admin/hardware_locations/" + payload.hl_id);
  },
  getHardwarelocationByCinema: function getHardwarelocationByCinema(payload) {
    return (0, _Api2.default)().get("/api/admin/get_pos_hardware_location_by_cinema/" + payload.cinema_id);
  },
  UpdatePosHardwareSettings: function UpdatePosHardwareSettings(payload) {
    return (0, _Api2.default)().put("/api/admin/update_pos_hardware_settings", payload);
  },
  getPosHardwareSettings: function getPosHardwareSettings(payload) {
    return (0, _Api2.default)().get("/api/admin/get_pos_hardware_settings/" + payload.unique_id);
  },
  GetAllCinema: function GetAllCinema(payload) {
    return (0, _Api2.default)().post("/api/pos/getcinemaslist", payload);
  }
};

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_loader_vue__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_connection_lost_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_globalModal_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_navLists__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_navLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_navLists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_MasterService__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_MasterService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_MasterService__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__components_Partials_loader_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_Partials_globalModal_vue__["a" /* default */],
    connectionLost: __WEBPACK_IMPORTED_MODULE_2__components_Partials_connection_lost_vue__["a" /* default */]
  },
  data: function data() {
    return {
      onLine: navigator.onLine

    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // return store.fetchSpecial(to.params.slug).then(next)
    next();
  },
  beforeMount: function beforeMount() {},
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  mounted: function mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.fetchGlobalOptions();
  },

  computed: {
    navBarItems: function navBarItems() {
      return __WEBPACK_IMPORTED_MODULE_4__helper_navLists___default.a;
    },
    currentNavName: function currentNavName() {
      var _this = this;

      var navName = "";
      var navIndex = this.navBarItems.findIndex(function (navObj) {
        return navObj.url == _this.$route.path;
      });
      if (navIndex >= 0) {
        navName = this.navBarItems[navIndex].name;
      } else {
        return;
      }
      return navName;
    }
  },
  methods: {
    homePage: function homePage() {
      this.$router.push("/reports");
    },
    analytictPage: function analytictPage() {
      this.$router.push("/AnalyticsSection");
    },
    updateOnlineStatus: function updateOnlineStatus(e) {
      var type = e.type;

      this.onLine = type === "online";
    },

    fetchGlobalOptions: function fetchGlobalOptions() {
      __WEBPACK_IMPORTED_MODULE_5__services_MasterService___default.a.GetGlobalOptions().then(function (response) {
        var data = response.data;

        console.log("Client_name", data);
        if (data && data.status && data.Records.length > 0) {
          var CLIENT_SETUP_NAME = data.Records.find(function (go) {
            return go.go_key == "CLIENT_SETUP_NAME";
          });
          console.log("CLIENT_SETUP_NAME", CLIENT_SETUP_NAME);
          localStorage.setItem("setUpName", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(CLIENT_SETUP_NAME.go_value));
        } else {
          console.log("Erro in fetching global options");
        }
      });
    }
  }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ConnectionLost",
  methods: {
    retry: function retry() {
      window.location.reload();
    }
  }
});

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createQueryString = undefined;

var _toConsumableArray2 = __webpack_require__(603);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(163);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQueryString = exports.createQueryString = function createQueryString() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var query = "";
    if ((0, _keys2.default)(payload).length > 0) {
        var urlparams = new URLSearchParams();
        for (var key in payload) {
            if (payload[key]) {
                urlparams.append(key, payload[key]);
            }
        }
        if ([].concat((0, _toConsumableArray3.default)(urlparams.entries())).length > 0) {
            query += "?" + urlparams.toString();
        }
    }
    return query;
};

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Role = exports.Role = {
  SuperAdmin: "Super Admin",
  HoManager: "HO Manager",
  CinemaManager: "Cinema Manager",
  PosOperator: "POS Operator", // PosOperator: 'POS Operator',
  PosFnBOperator: "FnB POS Operator",
  Distributor: "Distributor",
  BoxOfficeFnbOperator: "Box Office Fnb",
  AnalyticsManager: "Analytics Manager",
  KitchenManager: "Kitchen Manager",
  ProgrammingManager: "Programming Manager"
};

var CLIENT_NAME = exports.CLIENT_NAME = {
  CINEMA_AKIL: "Cinema Akil",
  EMPIRE: "empire",
  STUESSIHOF: "stuessihof",
  XANADU: "xanadu",
  PETRO: "petro",
  IRAQ: "Iraq",
  LEBANON: "lebanon",
  BILDHAUS: "bildhaus",
  QFX: "qfx",
  STAR: "starcinemas"
};

var CLIENT_NAMES_OBJ = exports.CLIENT_NAMES_OBJ = {
  empire_combo: ["empire", "petro", "Iraq", "starcinemas", "lebanon"],
  empire_iraq: ["empire", "Iraq"],
  multiple_ticket_clients: ["bildhaus", "carnival"],
  empire_iraq_lebanon: ["empire", "Iraq", "lebanon"],
  empire_clients: ["empire", "Iraq", "lebanon", "petro"],
  iraq: ["Iraq"],
  empire: ["empire"],
  xanadu: ["xanadu"],
  petro: ["petro"],
  stuessihof: ["stuessihof"],
  lebanon: ["lebanon"],
  bildhaus: ["bildhaus"],
  qfx: ["qfx"],
  star: ["starcinemas"],
  carnival: ["carnival"],
  bildhaus_qfx: ["bildhaus", "qfx"]
};

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var navLists = [{
  id: 1,
  name: "Booking Report - Summary",
  url: "/booking-summary"
}, {
  id: 2,
  name: "Transaction Hourly",
  url: "/transaction-hourly"
}, {
  id: 3,
  name: "Cinemawise Sales Summary",
  url: "/cinema-wise-sales"
}, {
  id: 4,
  name: "Moviewise - Summary",
  url: "/movie-wise-sales"
}, {
  id: 5,
  name: "Sales Report",
  url: "/sales-summary"
},
// {
//   id: 6,
//   name: "Complimentary Report",
//   url: "/booking-summary",
// },
{
  id: 7,
  name: "Schedule Report",
  url: "/schedule-report"
}, {
  id: 8,
  name: "FB Sale Summary",
  url: "/fb-sale-summary"
}, {
  id: 9,
  name: "Occupancy Report",
  url: "/occupancy-report"
}, {
  id: 9,
  name: "Week Wise Movie History",
  url: "/week-wise-movie-history"
}, {
  id: 10,
  name: "Movie Summary Report",
  url: "/movie-summary-report"
}, {
  id: 11,
  name: "Movie Show Wise Report",
  url: "/movie-show-wise-report"
}, {
  id: 11,
  name: "Summary Report",
  url: "/new-summary"
}];

exports.default = navLists;

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVR4nO3WsQkAMQwEweu/LKmwd2wwOLZ+BlTAouQSAGDTSb7HrqeE1CkEAACuXly/PSWk7v8BAIAh67enhNQpBAB+awHE9RApipkrkgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

__webpack_require__(619);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(807);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(876);

var _router2 = _interopRequireDefault(_router);

var _bootstrapVue = __webpack_require__(881);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueToasted = __webpack_require__(919);

var _vueToasted2 = _interopRequireDefault(_vueToasted);

var _vuejsDatepicker = __webpack_require__(920);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _vueLazyload = __webpack_require__(921);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

__webpack_require__(922);

__webpack_require__(923);

__webpack_require__(924);

var _vueCookie = __webpack_require__(925);

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _utilMixin = __webpack_require__(927);

var _utilMixin2 = _interopRequireDefault(_utilMixin);

__webpack_require__(934);

__webpack_require__(935);

__webpack_require__(936);

__webpack_require__(937);

__webpack_require__(938);

__webpack_require__(939);

__webpack_require__(940);

var _index = __webpack_require__(92);

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(941);

var _vueMultiselect = __webpack_require__(942);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _vueLoadingOverlay = __webpack_require__(943);

var _vueLoadingOverlay2 = _interopRequireDefault(_vueLoadingOverlay);

__webpack_require__(944);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.use(_vueCookie2.default);
// mixin

_vue2.default.component("multiselect", _vueMultiselect2.default);

// Import component

// Import stylesheet


// import VueChartJS from "vue-chartjs";
// Vue.use(VueChartJS);

_vue2.default.use(_vueLazyload2.default, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1
});

// added loader
_vue2.default.use(_vueLoadingOverlay2.default, {
  loader: "bars",
  color: "#c74c47",
  width: 70,
  zIndex: 9999,
  height: 50,
  backgroundColor: "#4b4b4b"
});
_vue2.default.mixin(_utilMixin2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.component("Datepicker", _vuejsDatepicker2.default);

_vue2.default.config.productionTip = false;

// toast message
_vue2.default.use(_vueToasted2.default, {
  duration: 2000,
  position: "bottom-center",
  singleton: true,
  containerClass: "toast-message",
  className: "toastedContainer"
});

// Created the Event Bus for the call parent function
var EventBus = exports.EventBus = new _vue2.default();

// socket import

/* eslint-disable no-new */
var vm = new _vue2.default({
  el: "#app",
  router: _router2.default,
  template: "<App/>",
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(297);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360fcc2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(873);
function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var normalizeComponent = __webpack_require__(119)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_360fcc2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3478ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__(812);
var normalizeComponent = __webpack_require__(119)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3478ccb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-bg"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Loading")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connection_lost_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d4f830_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connection_lost_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(119)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connection_lost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d4f830_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connection_lost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 814:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-connection-lost"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"alt":"Connection Lost","height":"75","src":__webpack_require__(816),"width":"75"}}),_vm._v(" "),_c('h6',{staticClass:"mb-1"},[_vm._v("Oops!")]),_vm._v(" "),_c('h6',{staticClass:"mb-5"},[_vm._v("Connection Lost")]),_vm._v(" "),_c('div',{staticClass:"proceed-btn"},[_c('button',{staticClass:"btn py-md-2 px-md-3",attrs:{"type":"button"},on:{"click":_vm.retry}},[_vm._v("\n        Retry\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36e9d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalModal_vue__ = __webpack_require__(819);
function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var normalizeComponent = __webpack_require__(119)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36e9d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-modal"},[_c('div',{staticClass:"modal-container"},[_c('header',[_vm._v("Alert")]),_vm._v(" "),_c('div',{staticClass:"global-modal-content"},[_c('h5',[_vm._v("Are you Sure you Want to delete this item?")])]),_vm._v(" "),_c('footer',{staticClass:"global-modal-footer"},[_c('button',{staticClass:"btn-blue mx-1"},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn-outline-blue mx-1"},[_vm._v("No")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.$route.path != '/reports' && _vm.$route.path != '/')?_c('div',{staticClass:"d-flex bgNavbarHeader justify-content-md-normal"},[(_vm.$route.path !== '/' && _vm.$route.path != '/AnalyticsSection')?_c('p',{staticClass:"backBtnContainer ml-2 ml-md-1 mt-1",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{staticClass:"w-100 h-100",attrs:{"src":__webpack_require__(874),"alt":""}})]):_c('div',{staticClass:"pl-2"},[_c('img',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-1",modifiers:{"sidebar-1":true}}],staticClass:"ham_icon",attrs:{"alt":"Menu","src":__webpack_require__(617)}}),_vm._v(" "),_c('b-sidebar',{attrs:{"id":"sidebar-1","title":"","shadow":""}},[_c('div',{staticClass:"px-3 py-2 sub_menu"},[_c('p',{on:{"click":function($event){return _vm.homePage()}}},[_vm._v(" Home ")]),_vm._v(" "),_c('p',{style:(_vm.$route.path == '/AnalyticsSection' ? 'color:red' : ''),on:{"click":function($event){return _vm.analytictPage()}}},[_vm._v("\n              Analytics Reports\n            ")])])])],1),_vm._v(" "),_c('p',{staticClass:"text-center text-light my-0 module_name_container mx-auto mt-1"},[_vm._v(_vm._s(_vm.$route.meta.subName))]),_vm._v(" "),_c('img',{staticStyle:{"margin-right":"40px","height":"25px"},attrs:{"src":__webpack_require__(875),"alt":""},on:{"click":function($event){return _vm.analytictPage()}}})]):_vm._e(),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQ5MiA0OTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ5MiA0OTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiBmaWxsPSIjZmZmZmZmIj4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNDY0LjM0NCwyMDcuNDE4bDAuNzY4LDAuMTY4SDEzNS44ODhsMTAzLjQ5Ni0xMDMuNzI0YzUuMDY4LTUuMDY0LDcuODQ4LTExLjkyNCw3Ljg0OC0xOS4xMjQKCQkJYzAtNy4yLTIuNzgtMTQuMDEyLTcuODQ4LTE5LjA4OEwyMjMuMjgsNDkuNTM4Yy01LjA2NC01LjA2NC0xMS44MTItNy44NjQtMTkuMDA4LTcuODY0Yy03LjIsMC0xMy45NTIsMi43OC0xOS4wMTYsNy44NDQKCQkJTDcuODQ0LDIyNi45MTRDMi43NiwyMzEuOTk4LTAuMDIsMjM4Ljc3LDAsMjQ1Ljk3NGMtMC4wMiw3LjI0NCwyLjc2LDE0LjAyLDcuODQ0LDE5LjA5NmwxNzcuNDEyLDE3Ny40MTIKCQkJYzUuMDY0LDUuMDYsMTEuODEyLDcuODQ0LDE5LjAxNiw3Ljg0NGM3LjE5NiwwLDEzLjk0NC0yLjc4OCwxOS4wMDgtNy44NDRsMTYuMTA0LTE2LjExMmM1LjA2OC01LjA1Niw3Ljg0OC0xMS44MDgsNy44NDgtMTkuMDA4CgkJCWMwLTcuMTk2LTIuNzgtMTMuNTkyLTcuODQ4LTE4LjY1MkwxMzQuNzIsMjg0LjQwNmgzMjkuOTkyYzE0LjgyOCwwLDI3LjI4OC0xMi43OCwyNy4yODgtMjcuNnYtMjIuNzg4CgkJCUM0OTIsMjE5LjE5OCw0NzkuMTcyLDIwNy40MTgsNDY0LjM0NCwyMDcuNDE4eiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PCEtLSA8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjE3IiB2aWV3Qm94PSIwIDAgMjAgMTciPgogIDxwYXRoIGlkPSJJY29uIiBkPSJNNzMzLTMyOHYtNmg0djZoNXYtOGgzbC0xMC05LTEwLDloM3Y4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcyNSAzNDUpIiBmaWxsPSIjZDlkOWQ5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+IC0tPgoKCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMCAxNyI+CiAgPHBhdGggaWQ9Ikljb24iIGQ9Ik03MzMtMzI4di02aDR2Nmg1di04aDNsLTEwLTktMTAsOWgzdjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzI1IDM0NSkiIGZpbGw9IiNkOWQ5ZDkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSJibGFjayIgLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(877);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _config = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: "hash",
  routes: [{
    path: "/reports",
    name: "ReportsHome",
    // meta: {
    //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
    // },
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 947));
    }
  }, {
    path: "/",
    name: "LoginPage",
    // meta: {
    //   subName: `${CLIENT_NAME ? CLIENT_NAME : "Star"} Cinemas Reports`,
    // },
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 948));
    }
  }, {
    path: "/AnalyticsSection",
    name: "AnalyticsSection",
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 949));
    }
  }, {
    path: "/booking-summary",
    name: "BookingSummary",
    meta: { subName: "Booking Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 950));
    }
  }, {
    path: "/transaction-hourly",
    name: "transactionHourly",
    meta: { subName: "Transaction Hourly" },

    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 951));
    }
  }, {
    path: "/transaction-hourly/:hour/:fromDate/:toDate",
    name: "transactionHourlyDetailed",
    meta: { subName: "Transaction Hourly" },

    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 952));
    }
  }, {
    path: "/cinema-wise-sales",
    name: "CinemaWiseSalesRecords",
    meta: { subName: "Cinema Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 953));
    }
  }, {
    path: "/cinema-wise-sales/:cinema_id/:fromDate/:toDate",
    name: "CinemaWiseMovieSales",
    meta: { subName: "Cinema Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 954));
    }
  }, {
    path: "/movie-wise-sales",
    name: "MovieWiseSalesRecords",
    meta: { subName: "Movie Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 955));
    }
  }, {
    path: "/movie-wise-sales/:md_id/:fromDate/:toDate",
    name: "MovieWiseCinemaSales",
    meta: { subName: "Movie Wise Sales" },

    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 956));
    }
  }, {
    path: "/sales-summary",
    name: "DailySalesReport",
    meta: { subName: "Daily Sales Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 957));
    }
  }, {
    path: "/sales-summary/:cinema_id/:fromDate/:toDate",
    name: "DailySalesDetailedReport",
    meta: { subName: "Daily Sales Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 958));
    }
  }, {
    path: "/schedule-report",
    name: "ScheduleReportVenue",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 959));
    }
  }, {
    path: "/schedule-report/:cinema_id",
    name: "ScheduleReportVenueBasedMovie",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 960));
    }
  }, {
    path: "/schedule-report/:cinema_id/:md_id",
    name: "cinemaMovieSchedules",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 961));
    }
  }, {
    path: "/schedule-movie-report/:md_id",
    name: "movieCinemaSchedules",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 962));
    }
  }, {
    path: "/schedule-movie-report/:md_id/:cinema_id",
    name: "movieScheduledCinemaScreen",
    meta: { subName: "Schedule Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 963));
    }
  }, {
    path: "/fb-sale-summary",
    name: "FnBSalesSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 964));
    }
  }, {
    path: "/fb-sale-summary/:source_type/:fromDate/:toDate",
    name: "FnBSalesCinemaSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 965));
    }
  }, {
    path: "/fb-sale-summary/:cinema_id/:source_type/:fromDate/:toDate",
    name: "FnBSalesItemCinemaWiseSummary",
    meta: { subName: "FB Sale Summary" },

    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 966));
    }
  }, {
    path: "/occupancy-report",
    name: "cinemaOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 967));
    }
  }, {
    path: "/occupancy-report/:cinema_id",
    name: "movieOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 968));
    }
  }, {
    path: "/occupancy-report/:cinema_id/:md_id",
    name: "screenOccupancyReport",
    meta: { subName: "Occupancy Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 969));
    }
  }, {
    path: "/week-wise-movie-history",
    name: "weekWiseMovieHistory",
    meta: { subName: "Week Wise Movie History Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 970));
    }
  }, {
    path: "/movie-summary-report",
    name: "movieSummaryReport",
    meta: { subName: "Movie Summary Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 971));
    }
  }, {
    path: "/movie-show-wise-report",
    name: "movieShowWiseReport",
    meta: { subName: "Movie Show Wise Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 972));
    }
  }, {
    path: "/new-summary",
    name: "SummaryReport",
    meta: { subName: "Summary Report" },

    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 973));
    }
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(function (to, from, next) {
  console.log({ to: to, from: from });
  var isAuthenticated = localStorage.getItem("IsloggedIn") == "Y";

  if (isAuthenticated && to.name == "LoginPage") next({ name: "ReportsHome" });

  if (to.name !== "LoginPage" && !isAuthenticated) next({ name: "LoginPage" });else next();
});

exports.default = router;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 319,
	"./af.js": 319,
	"./ar": 320,
	"./ar-dz": 321,
	"./ar-dz.js": 321,
	"./ar-kw": 322,
	"./ar-kw.js": 322,
	"./ar-ly": 323,
	"./ar-ly.js": 323,
	"./ar-ma": 324,
	"./ar-ma.js": 324,
	"./ar-ps": 325,
	"./ar-ps.js": 325,
	"./ar-sa": 326,
	"./ar-sa.js": 326,
	"./ar-tn": 327,
	"./ar-tn.js": 327,
	"./ar.js": 320,
	"./az": 328,
	"./az.js": 328,
	"./be": 329,
	"./be.js": 329,
	"./bg": 330,
	"./bg.js": 330,
	"./bm": 331,
	"./bm.js": 331,
	"./bn": 332,
	"./bn-bd": 333,
	"./bn-bd.js": 333,
	"./bn.js": 332,
	"./bo": 334,
	"./bo.js": 334,
	"./br": 335,
	"./br.js": 335,
	"./bs": 336,
	"./bs.js": 336,
	"./ca": 337,
	"./ca.js": 337,
	"./cs": 338,
	"./cs.js": 338,
	"./cv": 339,
	"./cv.js": 339,
	"./cy": 340,
	"./cy.js": 340,
	"./da": 341,
	"./da.js": 341,
	"./de": 342,
	"./de-at": 343,
	"./de-at.js": 343,
	"./de-ch": 344,
	"./de-ch.js": 344,
	"./de.js": 342,
	"./dv": 345,
	"./dv.js": 345,
	"./el": 346,
	"./el.js": 346,
	"./en-au": 347,
	"./en-au.js": 347,
	"./en-ca": 348,
	"./en-ca.js": 348,
	"./en-gb": 349,
	"./en-gb.js": 349,
	"./en-ie": 350,
	"./en-ie.js": 350,
	"./en-il": 351,
	"./en-il.js": 351,
	"./en-in": 352,
	"./en-in.js": 352,
	"./en-nz": 353,
	"./en-nz.js": 353,
	"./en-sg": 354,
	"./en-sg.js": 354,
	"./eo": 355,
	"./eo.js": 355,
	"./es": 356,
	"./es-do": 357,
	"./es-do.js": 357,
	"./es-mx": 358,
	"./es-mx.js": 358,
	"./es-us": 359,
	"./es-us.js": 359,
	"./es.js": 356,
	"./et": 360,
	"./et.js": 360,
	"./eu": 361,
	"./eu.js": 361,
	"./fa": 362,
	"./fa.js": 362,
	"./fi": 363,
	"./fi.js": 363,
	"./fil": 364,
	"./fil.js": 364,
	"./fo": 365,
	"./fo.js": 365,
	"./fr": 366,
	"./fr-ca": 367,
	"./fr-ca.js": 367,
	"./fr-ch": 368,
	"./fr-ch.js": 368,
	"./fr.js": 366,
	"./fy": 369,
	"./fy.js": 369,
	"./ga": 370,
	"./ga.js": 370,
	"./gd": 371,
	"./gd.js": 371,
	"./gl": 372,
	"./gl.js": 372,
	"./gom-deva": 373,
	"./gom-deva.js": 373,
	"./gom-latn": 374,
	"./gom-latn.js": 374,
	"./gu": 375,
	"./gu.js": 375,
	"./he": 376,
	"./he.js": 376,
	"./hi": 377,
	"./hi.js": 377,
	"./hr": 378,
	"./hr.js": 378,
	"./hu": 379,
	"./hu.js": 379,
	"./hy-am": 380,
	"./hy-am.js": 380,
	"./id": 381,
	"./id.js": 381,
	"./is": 382,
	"./is.js": 382,
	"./it": 383,
	"./it-ch": 384,
	"./it-ch.js": 384,
	"./it.js": 383,
	"./ja": 385,
	"./ja.js": 385,
	"./jv": 386,
	"./jv.js": 386,
	"./ka": 387,
	"./ka.js": 387,
	"./kk": 388,
	"./kk.js": 388,
	"./km": 389,
	"./km.js": 389,
	"./kn": 390,
	"./kn.js": 390,
	"./ko": 391,
	"./ko.js": 391,
	"./ku": 392,
	"./ku-kmr": 393,
	"./ku-kmr.js": 393,
	"./ku.js": 392,
	"./ky": 394,
	"./ky.js": 394,
	"./lb": 395,
	"./lb.js": 395,
	"./lo": 396,
	"./lo.js": 396,
	"./lt": 397,
	"./lt.js": 397,
	"./lv": 398,
	"./lv.js": 398,
	"./me": 399,
	"./me.js": 399,
	"./mi": 400,
	"./mi.js": 400,
	"./mk": 401,
	"./mk.js": 401,
	"./ml": 402,
	"./ml.js": 402,
	"./mn": 403,
	"./mn.js": 403,
	"./mr": 404,
	"./mr.js": 404,
	"./ms": 405,
	"./ms-my": 406,
	"./ms-my.js": 406,
	"./ms.js": 405,
	"./mt": 407,
	"./mt.js": 407,
	"./my": 408,
	"./my.js": 408,
	"./nb": 409,
	"./nb.js": 409,
	"./ne": 410,
	"./ne.js": 410,
	"./nl": 411,
	"./nl-be": 412,
	"./nl-be.js": 412,
	"./nl.js": 411,
	"./nn": 413,
	"./nn.js": 413,
	"./oc-lnc": 414,
	"./oc-lnc.js": 414,
	"./pa-in": 415,
	"./pa-in.js": 415,
	"./pl": 416,
	"./pl.js": 416,
	"./pt": 417,
	"./pt-br": 418,
	"./pt-br.js": 418,
	"./pt.js": 417,
	"./ro": 419,
	"./ro.js": 419,
	"./ru": 420,
	"./ru.js": 420,
	"./sd": 421,
	"./sd.js": 421,
	"./se": 422,
	"./se.js": 422,
	"./si": 423,
	"./si.js": 423,
	"./sk": 424,
	"./sk.js": 424,
	"./sl": 425,
	"./sl.js": 425,
	"./sq": 426,
	"./sq.js": 426,
	"./sr": 427,
	"./sr-cyrl": 428,
	"./sr-cyrl.js": 428,
	"./sr.js": 427,
	"./ss": 429,
	"./ss.js": 429,
	"./sv": 430,
	"./sv.js": 430,
	"./sw": 431,
	"./sw.js": 431,
	"./ta": 432,
	"./ta.js": 432,
	"./te": 433,
	"./te.js": 433,
	"./tet": 434,
	"./tet.js": 434,
	"./tg": 435,
	"./tg.js": 435,
	"./th": 436,
	"./th.js": 436,
	"./tk": 437,
	"./tk.js": 437,
	"./tl-ph": 438,
	"./tl-ph.js": 438,
	"./tlh": 439,
	"./tlh.js": 439,
	"./tr": 440,
	"./tr.js": 440,
	"./tzl": 441,
	"./tzl.js": 441,
	"./tzm": 442,
	"./tzm-latn": 443,
	"./tzm-latn.js": 443,
	"./tzm.js": 442,
	"./ug-cn": 444,
	"./ug-cn.js": 444,
	"./uk": 445,
	"./uk.js": 445,
	"./ur": 446,
	"./ur.js": 446,
	"./uz": 447,
	"./uz-latn": 448,
	"./uz-latn.js": 448,
	"./uz.js": 447,
	"./vi": 449,
	"./vi.js": 449,
	"./x-pseudo": 450,
	"./x-pseudo.js": 450,
	"./yo": 451,
	"./yo.js": 451,
	"./zh-cn": 452,
	"./zh-cn.js": 452,
	"./zh-hk": 453,
	"./zh-hk.js": 453,
	"./zh-mo": 454,
	"./zh-mo.js": 454,
	"./zh-tw": 455,
	"./zh-tw.js": 455
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

var BASEURL = exports.BASEURL = "https://megacinemas-api.nuviotech.co";

// export const ImageS3URL = `https://images.brijimages.com/`;
var IMGBASEURL = exports.IMGBASEURL = "https://megacinemas-api.nuviotech.co";

var fallbackImgSrc = exports.fallbackImgSrc = BASEURL + "assets/fallback-image.png";
var fallbackImgBannerSrc = exports.fallbackImgBannerSrc = BASEURL + "assets/fallback-image-banner.png";
var SALES_APP = exports.SALES_APP = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjNjNzM0ODk3LTc0OWMtNDMxNC1iY2I1LWE1MDU2YzRmMWY2MCIsImlhdCI6MTc0NjE3Mzc1NH0.KEZiCddGMNZI90XO_07ZOhMFsnyJIFWiUVGyVd3JI4k";
var TOKEN = exports.TOKEN = SALES_APP;

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineDateAndTime = undefined;

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter("time", function (value) {
  var is24HrFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value) {
    var date = new Date(Date.parse(value));
    var hours = date.getHours();
    var min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      var time = hours > 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

_vue2.default.filter("timeFormat", function (value) {
  if (value) {
    var dateString = combineDateAndTime(value);
    var format = window.localStorage.getItem("TimeFormat") ? window.localStorage.getItem("TimeFormat") : "HH:mm";
    if (format) {
      return (0, _moment2.default)(dateString).format(format);
    } else {
      return (0, _moment2.default)(dateString).format("HH:mm");
    }
  } else {
    return "-";
  }
});

_vue2.default.filter("weekOfMonth", function (value) {
  if (value) {
    var date = (0, _moment2.default)(value);
    var weekInYearIndex = date.week();
    if (date.year() !== date.weekYear()) {
      weekInYearIndex = date.clone().subtract(1, "week").week() + 1;
    }
    var weekIndex = weekInYearIndex - (0, _moment2.default)(date).startOf("month").week() + 1;
    return weekIndex;
  } else {
    return "-";
  }
});

_vue2.default.filter("timefornotification", function (value) {
  var is24HrFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (value) {
    var date = new Date(Date.parse(value));
    var hours = date.getHours();
    var min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      var time = hours < 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

_vue2.default.filter("format12hours", function (value) {
  if (!value) return "-";else if (value) return value ? (0, _moment2.default)(value, ["HH:mm"]).format("h:mm A") : "-";
});

_vue2.default.filter("format24hours", function (value) {
  if (!value) return "-";else if (value) return value ? (0, _moment2.default)(value, ["h:mm A"]).format("HH:mm") : "-";
});

////////////////////////
_vue2.default.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

_vue2.default.filter("uppercase", function (value) {
  if (!value) return value || "";
  return value.toUpperCase();
});

_vue2.default.filter("activeParse", function (value) {
  if (!value) return value || "";
  return value === "Y" ? "Yes" : value === "N" ? "No" : "";
});
_vue2.default.filter("dateparse-movies", function (value) {
  console.log("value", value);
  console.log("value1", (0, _moment2.default)(value, "DD/MM/YYYY"));
  value = (0, _moment2.default)(value, "DD/MM/YYYY");
  if (!value) return "-";else if (value === "Invalid date") return "-";else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY") === "Invalid date" ? "-" : (0, _moment2.default)(value).format("DD MMM YYYY") : "-";
});

_vue2.default.filter("dateparse", function (value) {
  if (!value) return "-";else if (value === "Invalid date") return "-";else if ((0, _moment2.default)(value, "DD-MM-YYYY HH:mm", true).isValid()) return value ? (0, _moment2.default)(value, "DD-MM-YYYY HH:mm").format("DD MMM YYYY") : "-";
  //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
  //this is changed acc to mams decision
  else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY") === "Invalid date" ? "-" : (0, _moment2.default)(value).format("DD MMM YYYY") : "-";
});
_vue2.default.filter("dayparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value, "DD-MM-YYYY").calendar(null, {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "[last] dddd",
    nextWeek: "dddd",
    sameElse: "dddd"
  }) : "-";
});

_vue2.default.filter("daynumber", function (value) {
  if (!value) return "-";else if (value && (0, _moment2.default)(value).format("dddd") === "Friday") return "1";else if (value && (0, _moment2.default)(value).format("dddd") === "Saturday") return "2";else if (value && (0, _moment2.default)(value).format("dddd") === "Sunday") return "3";else if (value && (0, _moment2.default)(value).format("dddd") === "Monday") return "4";else if (value && (0, _moment2.default)(value).format("dddd") === "Tuesday") return "5";else if (value && (0, _moment2.default)(value).format("dddd") === "Wednesday") return "6";else if (value && (0, _moment2.default)(value).format("dddd") === "Thursday") return "7";
});

// moment().format("dddd")
_vue2.default.filter("daydate", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("ddd") + " " + (0, _moment2.default)(value).format("DD") : "-";
});

_vue2.default.filter("fulldateparse", function (value) {
  var isInvalid = String(value).toLowerCase();
  if (isInvalid.includes('invalid') || isInvalid.includes('null') || isInvalid.includes('undefined')) return '-';

  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("DD-MM-YYYY HH:MM") : "-";
});

_vue2.default.filter("timeparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("LT") : "-";
});

_vue2.default.filter("temptimeparse", function () {});

_vue2.default.filter("getDay", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("dddd") : "-";
});

_vue2.default.filter("getMonth", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("MMMM") : "-";
});

_vue2.default.filter("getDayDigit", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("Do") : "-";
});

_vue2.default.filter("dayonly3", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("ddd") : "-";
});

_vue2.default.filter("timeparseAmPm", function (value) {
  // console.log('value :', value);
  if (!value) return "-";else return value ? (0, _moment2.default)((0, _moment2.default)(new Date()).format("DD-MM-YYYY") + " " + value, "DD-MM-YYYY HH:mm").format("h:mm A") : "-";
});

// Vue.filter('datetimeparseAmPm', function (value) {
//     console.log('value :', value);
//     if (!value) return '-'
//     else return value ? moment(`${moment(new Date()).format('DD-MM-YYYY')} ${value}`, 'DD-MM-YYYY HH:mm').format('h:mm A') : '-'
// });

_vue2.default.filter("fulldatemonparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("DD-MMM-YYYY HH:mm") : "-";
});

_vue2.default.filter("dateFormat", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("YYYY-MM-DD") : "-";
});

_vue2.default.filter("time", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("HH:mm") : "-";
});

_vue2.default.filter("fulldaydateparse", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(new Date(value)).format("MMMM Do YYYY, HH:mm") : "-";
});

_vue2.default.filter("RoundOff", function (value) {
  if (!value) return "0";else return value ? Math.round(value * 100) / 100 : "-";
});

_vue2.default.filter("TimeStamptoDate", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value * 1000).format("YYYY-MM-DD") : "-";
});

_vue2.default.filter("convertTo12Hours", function (value) {
  if (!value) return "-";else {
    // Check correct time format and split into components
    value = value.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [value];

    if (value.length > 1) {
      // If time format correct
      value = value.slice(1); // Remove full string match value
      value[5] = +value[0] < 12 ? " AM" : " PM"; // Set AM/PM
      value[0] = +value[0] % 12 || 12; // Adjust hours
    }
    return value.join(""); // return adjusted time or original strin
  }
});

_vue2.default.filter("TimeStamptoTime", function (value) {
  if (!value) return "-";else if (value.toString().length == 10) return value ? (0, _moment2.default)(value * 1000).format("hh:mm A") : "-";else return value ? (0, _moment2.default)(value).format("hh:mm A") : "-";
});

_vue2.default.filter("filterNullUndefined", function (value) {
  if (!value) return "-";
  return value;
});

_vue2.default.filter("negativeValue", function (value) {
  if (!value) return parseFloat(0).toFixed(2);
  return "" + ("-" + value);
});

_vue2.default.filter("dateParseYYYYMMDD", function (value) {
  if (!value) return "-";else return value ? (0, _moment2.default)(value).format("YYYY-MM-DD HH:mm") : "-";
});

_vue2.default.filter("orderStatusTag", function (value) {
  if (value == "Complete") {
    return "Ready";
  } else if (value == "Cancel") {
    return "Cancelled";
  } else {
    return value;
  }
});

var combineDateAndTime = exports.combineDateAndTime = function combineDateAndTime(time) {
  var timeString = time;
  var dateString = (0, _moment2.default)().format("YYYY-MM-DD");
  var combined = new Date(dateString + " " + timeString);

  return combined;
};

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(125);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(601);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(602);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(256);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(163);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(160);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(86);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(92);

var _constant = __webpack_require__(928);

var _constant2 = _interopRequireDefault(_constant);

var _currencyFormat = __webpack_require__(929);

var _Languages = __webpack_require__(930);

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

var _AuthenticationService = __webpack_require__(931);

var _MasterService = __webpack_require__(257);

var _MasterService2 = _interopRequireDefault(_MasterService);

var _LogService = __webpack_require__(932);

var _LogService2 = _interopRequireDefault(_LogService);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _Role = __webpack_require__(610);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var beforeMount = function beforeMount() {
  // this.$store.dispatch("fetchGlobalOptions");
  // this.$store.dispatch("fetchOrgDetails");
};
// import { getLangSpecificContent } from "@/helper/LanguageHelperV2";


var userDetailsArray = {
  cinema_id: null,
  email_id: null,
  first_name: null,
  last_name: null,
  middle_name: null,
  mobile_no: null,
  role_id: null,
  user_id: null,
  username: null,
  role_name: null,
  distributor_id: null,
  cine_name: null,
  cine_direct_sale: null,
  cine_include_float_amount: null,
  cine_sell_fnb_in_boxoffice: null,
  pos_location_access: null,
  is_premier_kitchen_user: "N"
};
var _data = function _data() {
  return {
    LOADING: null,
    AdminError: "Sorry! Something went wrong. kindly contact your administrator",
    GridViewFlag: false,
    NoRecords: "NoRecords",
    BASE_URL: _constant2.default.imageBaseURL,
    imageBaseURL: _constant2.default.imageBaseURL,
    imageS3BaseURL: _constant2.default.imageS3BaseURL,
    data_loading: false,
    usersArray: (0, _keys2.default)(userDetailsArray),
    UsersDetails: (0, _extends3.default)({}, userDetailsArray),
    OrganizationGlobalOptions: [],
    secureStore: {
      set: _AuthenticationService.authenticationService.set,
      get: _AuthenticationService.authenticationService.get,
      remove: function remove(key) {
        window.localStorage.removeItem(key);
      }
    },
    toursShownOnPage: [],
    getMycinemaStatus: "N"
  };
};
var computed = {
  globaloptionsArr: function globaloptionsArr() {
    return this.$store.getters.getGlobalOptions;
  },
  _getCountryList: function _getCountryList() {
    return function (key, Id) {
      return [];
    };
  },
  curr_code_mixin: function curr_code_mixin() {
    return this.$store.getters.getCurrencyData["curr_code"];
  },
  currency: function currency() {
    return this.$store.getters.getCurrencyData;
  },
  GetRoleId: function GetRoleId() {
    var _authenticationServic = _AuthenticationService.authenticationService.get("USINFO"),
        role_id = _authenticationServic.role_id;

    return role_id;
  },
  _DateFormat: function _DateFormat() {
    return _constant2.default.dateFormat;
  },

  // currFormat() {
  //   let cFormat;
  //   let precesion;
  //   let global_options_latest = this.$store.getters.getGlobalOptions;
  //   cFormat = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CURR_FORMAT";
  //       })
  //     : null;
  //   precesion = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "MIN_FRACTION_DIGITS";
  //       })
  //     : 2;
  //   if (cFormat && cFormat.go_value) {
  //     cFormat = cFormat.go_value;
  //   } else {
  //     cFormat = "en-US";
  //   }
  //   if (precesion && precesion.go_value) {
  //     precesion = precesion.go_value;
  //   } else {
  //     precesion = 2;
  //   }

  //   let CLIENT_SETUP_NAME = ""

  //   const CLIENTINFO = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CLIENT_SETUP_NAME";
  //       })
  //     : null;

  //     if(CLIENTINFO && CLIENTINFO.go_value) {
  //       CLIENT_SETUP_NAME = CLIENTINFO.go_value
  //     }

  //     console.log('CLIENT_SETUP_NAME', CLIENT_SETUP_NAME);
  //     console.log('CLIENT_NAME', this.CLIENT_NAME);


  //   if(CLIENT_SETUP_NAME == "starcinemas") {
  //     cFormat ='en-IN';
  //     precesion = 0;
  //   } else {
  //     precesion = precesion || 3;
  //   }
  //   return getNumberFormatter(cFormat, precesion);
  // },
  currFormat: function currFormat() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = [];
    var orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    var CLIENT_SETUP_NAME = "";
    if (CLIENT_SETUP_NAME == "starcinemas") {
      precesion = 0;
      cFormat = 'en-IN';
    } else {
      precesion = 2;
      cFormat = "en-US";
    }
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  currFormat4: function currFormat4() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = [];
    var orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    var CLIENT_SETUP_NAME = "";
    precesion = 0;
    cFormat = "en-US";
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  currFormat3: function currFormat3() {
    var cFormat = void 0;
    var precesion = void 0;
    var global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest ? global_options_latest.find(function (x) {
      return x.go_key == "CURR_FORMAT";
    }) : null;
    precesion = global_options_latest ? global_options_latest.find(function (x) {
      return x.go_key == "MIN_FRACTION_DIGITS";
    }) : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    precesion = 3;
    return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
  },
  CLIENT_SETUP_NAME: function CLIENT_SETUP_NAME() {
    return this.$store.getters.CLIENT_SETUP_NAME;
  },
  POS_AUDIT_LOGS_ACTIVE: function POS_AUDIT_LOGS_ACTIVE() {
    return this.$store.getters.POS_AUDIT_LOGS_ACTIVE;
  }
};

var getFirstUserData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(user_id) {
    var _ref2, data;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _MasterService2.default.GetUserInfoById({ user_id: user_id });

          case 2:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getFirstUserData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var methods = {
  sendAuditLogs: function sendAuditLogs(payload) {
    if (this.POS_AUDIT_LOGS_ACTIVE == "Y") {
      var logObj = (0, _extends3.default)({
        user_name: null,
        user_id: this.getUserDetail("user_id"),
        cinema_id: this.getCinemaId(),
        action: null,
        page_name: null,
        logDateTime: null,
        api_name: window.location.hash,
        ip: null,
        country_name: null,
        country_code: null,
        latitude: null,
        longitude: null,
        currency_code: null,
        currency_name: null
      }, payload);
      _LogService2.default.SendLog(logObj).then(function (response) {
        var data = response.data;

        if (data && data.status) {
          console.log("Log Inserted");
        } else {
          console.error("Status Error on sendLogs :", data.message);
        }
      }).catch(function (error) {
        console.error("Catch Error on sendLogs :", error);
      });
    }
  },
  authorizeClient: function authorizeClient(clientNames) {
    var isShow = false;
    var globaloptionsArr = this.globaloptionsArr;
    var clientSetupName = globaloptionsArr.find(function (globalOption) {
      return globalOption.go_key == "CLIENT_SETUP_NAME";
    })["go_value"];

    if (clientNames.length > 0 && clientSetupName) {
      isShow = clientNames.includes(clientSetupName);
    }
    console.log("this.$store.getters.CLIENT_SETUP_NAME", clientSetupName, clientNames, isShow, "from mixins");
    return isShow;
  },

  showLoading: function showLoading() {
    var _this = this;

    this.hideLoading(true);
    this.$nextTick(function () {
      _this.LOADING = _this.$loading.show();
    });
  },
  hideLoading: function hideLoading() {
    var _this2 = this;

    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!immediate) {
      this.$nextTick(function () {
        if (_this2.LOADING) _this2.LOADING.hide();
      });
    } else {
      if (this.LOADING) this.LOADING.hide();
    }
  },
  getRequestBody: function getRequestBody() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "GET";
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var Methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var payload = {};
    (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var promises;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promises = array.map(function (x) {
                payload[x.fieldname] = x.fieldvalue;
              });
              _context2.next = 3;
              return _promise2.default.all(promises);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }))();
    if (method == "POST") {
      return {
        url: Methods[method] + Methods["tableName"], // + Methods["urlKey"],
        method: method,
        payload: payload
      };
    } else if (method == "PUT") {
      var url = null;
      console.log("Method :", Methods["params"]);
      if (Methods["params"]) {
        url = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        url = Methods[method] + Methods["tableName"];
      }
      console.log("url :", url);

      return {
        url: url,
        method: "PUT",
        payload: payload
      };
    } else if (method == "GET") {
      var _url = null;
      if (Methods["params"]) {
        _url = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        _url = Methods[method] + Methods["tableName"];
      }

      return {
        url: _url,
        method: "GET",
        payload: {}
      };
    } else if (method == "GET_ONE") {
      var _url2 = null;
      if (Methods["params"]) {
        _url2 = Methods[method] + Methods["tableName"] + ("/" + Methods["params"]["id"]);
      } else {
        _url2 = Methods[method] + Methods["tableName"];
      }

      return {
        url: _url2,
        method: "GET",
        payload: {}
      };
    } else {
      return {
        url: "",
        method: "GET",
        payload: {}
      };
    }
  },
  /**
   * How to use Ref: [https://github.com/vuejs/vue/issues/11088#issuecomment-630287153]
   *  <template>
   *    <div>
   *      {{ getSafe(() => obj.foo.bar) }} ............................ <!-- returns 'baz' -->
   *      {{ getSafe(() => obj.foo.doesNotExist) }} ................... <!-- returns undefined -->
   *      {{ getSafe(() => obj.foo.doesNotExist, 'fallbackValue') }}... <!-- returns 'fallbackValue' -->
   *    </div>
   *  </template>
   */
  getSafe: function getSafe(fn) {
    var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var useFallbackForFalsyGetSafeValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    try {
      var result = fn();

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue;
      }

      return result;
    } catch (e) {
      return fallbackValue;
    }
  },
  validateShowCinema: function validateShowCinema(cinema_id) {
    console.log("VALIDATING CINEMA...", cinema_id, _AuthenticationService.authenticationService.get("USINFO").cinema_id);
    var loggedCinemaId = window.localStorage.getItem("cinema_id");
    var userId = _AuthenticationService.authenticationService.get("USINFO").user_id;
    var status = true;
    if (cinema_id && loggedCinemaId) {
      if (cinema_id == _AuthenticationService.authenticationService.get("USINFO").cinema_id && loggedCinemaId == cinema_id) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = false;
    }
    if (!status) {
      this.$store.dispatch("onSetAndSendLog", {
        action: "Validate Cinema ID FALIED WE GET SHOW CINEMA ID " + cinema_id + " but USER CINEMA ID IS " + loggedCinemaId + " and user id is " + userId,
        page_name: "POS booking",
        api_name: window.location.hash
      });
    }
    console.log("VALIDATE CINEMA STATUS", status);
    return status;
  },
  getNegativeValue: function getNegativeValue(value) {
    if (value) {
      return "-" + parseFloat(value).toFixed(2);
    } else {
      return parseFloat(0).toFixed(2);
    }
  },
  getGlobalOptionKey: function getGlobalOptionKey(key_name) {
    if (this.$store) {
      var global_array = this.$store.getters.getGlobalOptions;
      if (global_array.length > 0) {
        return global_array;
      }
    }
  },
  getMyCinemaStatusNew: function getMyCinemaStatusNew() {
    return this.secureStore.get("MYCINEMASTATUS");
  },

  goBack: function goBack(error) {
    this.$router.go(-1);
  },
  _CatchError: function _CatchError(error) {
    // console.log('errr::::', error)
    _vue2.default.toasted.show(error || "Sorry! Something went wrong. kindly contact your administrator");
  },
  _GoToSomethingWentWrong: function _GoToSomethingWentWrong() {
    this.$router.push({
      path: "/something-went-wrong"
    });
  },
  _GoToAccessDenied: function _GoToAccessDenied() {
    this.$router.push({
      path: "/access-denied"
    });
  },
  _GoToError404: function _GoToError404() {
    this.$router.push({
      path: "/404"
    });
  },
  _GoToRoute: function _GoToRoute(path) {
    this.$router.push({
      path: path
    });
  },

  GetViewUsersDetails: function GetViewUsersDetails(user_id) {
    var string = "";
    var promise = getFirstUserData(user_id).then(function (res) {
      string = res.status && res["Records"] && res.Records.length > 0 ? res.Records[0].user_name : "-";
    });
    // console.log('promise :', promise);
    // console.log('string :', string);
    // getFirstUserData(user_id).map(x => { console.log('x :', x); })
    return promise;
  },
  CreateFilterObject: function CreateFilterObject(array) {
    var obj = {};
    array.map(function (x) {
      obj[x.key] = "";
    });
    return obj;
  },
  GetMonthFirstDate: function GetMonthFirstDate() {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, "01"].join("-");
  },
  GetCurrentDate: function GetCurrentDate() {
    var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDate: function formatDate(date) {
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  },
  _formatDate_dd_mm_yyyy: function _formatDate_dd_mm_yyyy(date) {
    var d = new Date(date);
    var formatted_date = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
    return formatted_date;
  },

  _GetImagePath: function _GetImagePath(imagePath) {
    if (imagePath && imagePath.length > 0) {
      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);

      if (imagePath.match(regex)) {
        return imagePath;
      }
      if (imagePath.match(/S3\//g)) {
        return "" + _constant2.default.imageS3BaseURL + imagePath;
      } else {
        return "" + _constant2.default.imageBaseURL + imagePath;
      }
    }
  },

  _downloadImagePath: function _downloadImagePath(imagePath, fileName) {
    var imageUrl = "" + _constant2.default.imageBaseURL + imagePath;
    _axios2.default.get(imageUrl, { responseType: "blob" }).then(function (response) {
      console.log(response.data);
      var blob = new Blob([response.data]);
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(console.error);
  },
  getCurrentDateNew: function getCurrentDateNew(format) {
    if (format) {
      return (0, _moment2.default)().format(format);
    } else {
      return (0, _moment2.default)().format("YYYY-MM-DD");
    }
  },
  getCurrentTime: function getCurrentTime() {
    return (0, _moment2.default)().format("HH:mm");
  },
  getCinemaId: function getCinemaId() {
    return localStorage.getItem("cinema_id") || null;
  },
  getUserDetail: function getUserDetail() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var user_info = localStorage.getItem("USER_INFO") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_INFO"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getUserShiftData: function getUserShiftData() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var user_info = localStorage.getItem("USER_SHIFT_DATA") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_SHIFT_DATA"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getSpecificGlobalOption: function getSpecificGlobalOption() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var globalOptions = this.globaloptionsArr;
    var globalOptionValue = "";
    if (globalOptions.length > 0 && key != null) {
      var findGlobalOption = globalOptions.find(function (globalOption) {
        return globalOption.go_key === key;
      });
      if (findGlobalOption && (0, _keys2.default)(findGlobalOption).length > 0) {
        globalOptionValue = findGlobalOption.go_value;
      } else {
        globalOptionValue = "";
      }
    }
    console.log({ globalOptionValue: globalOptionValue }, "from globalOtpionValue");
    return globalOptionValue;
  },
  getReportDates: function getReportDates(reportRoute) {
    var fromDate = window.localStorage.getItem("fromDate");
    var toDate = window.localStorage.getItem("toDate");
    var obj = {
      fromDate: (0, _moment2.default)().format("YYYY-MM-DD"),
      toDate: (0, _moment2.default)().format("YYYY-MM-DD"),
      reportRoute: window.localStorage.getItem("reportRoute")
    };
    if (reportRoute == obj.reportRoute && fromDate && toDate) {
      obj["fromDate"] = (0, _moment2.default)(fromDate).format("YYYY-MM-DD");
      obj["toDate"] = (0, _moment2.default)(toDate).format("YYYY-MM-DD");
    }
    return obj;
  },
  setReportDates: function setReportDates(obj) {
    var objectKeys = (0, _keys2.default)(obj);
    if (objectKeys.length) {
      objectKeys.forEach(function (key) {
        window.localStorage.setItem(key, obj[key]);
      });
    }
    return true;
  },


  getLangSpecificAttribute: _Languages.getLangSpecificAttribute
  // getLangSpecificContent,
};

var beforeDestroy = function beforeDestroy() {};

var storeService = {
  data: function data() {
    return _data();
  },
  computed: computed,
  beforeMount: beforeMount,
  methods: methods,
  beforeDestroy: beforeDestroy
};

exports.default = storeService;

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(92);

exports.default = {
    imageBaseURL: _index.BASEURL,
    imageS3BaseURL: !!_index.IMGBASEURL ? _index.IMGBASEURL : "https://img-dev.brij.tech/",

    movieImages: {
        moviesUploadThumbnailImage: "280*350"
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
};

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getNumberFormatter = exports.getNumberFormatter = function getNumberFormatter(format, precesion) {
  return function (number) {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion != "undefined" ? precesion : 2,
        maximumFractionDigits: precesion != "undefined" ? precesion : 2
      });
    } else {
      return "0";
    }
  };
};

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLangSpecificAttribute = getLangSpecificAttribute;
exports.default = [{ flag: "us", language: "en", title: "English" }, { flag: "es", language: "es", title: "Español" }];
function getLangSpecificAttribute(languageSpecificImages, target_lang_id, attr) {
  if (!languageSpecificImages || languageSpecificImages.length === 0) return null;

  var target_obj = languageSpecificImages.find(function (x) {
    return x.content_lang_id === target_lang_id;
  });

  if (target_obj && target_obj[attr]) {
    return target_obj[attr];
  } else {
    // check english
    var eng_obj = getLangSpecificObject(languageSpecificImages, "english");
    if (eng_obj && eng_obj[attr]) {
      return eng_obj[attr];
    }

    // check german
    var german_obj = getLangSpecificObject(languageSpecificImages, "german");
    if (german_obj && german_obj[attr]) {
      return german_obj[attr];
    }

    // french
    // check german
    var french_obj = getLangSpecificObject(languageSpecificImages, "french");
    if (french_obj && french_obj[attr]) {
      return french_obj[attr];
    }

    // italian
    // check german
    var italian_obj = getLangSpecificObject(languageSpecificImages, "italian");
    if (italian_obj && italian_obj[attr]) {
      return italian_obj[attr];
    }
  }

  if (languageSpecificImages.length > 0) {
    return languageSpecificImages[0][attr];
  }

  return null;
}

function getLangSpecificObject(arr) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (arr && arr.length > 0) {
    var obj = arr.find(function (x) {
      return x.lang_name && x.lang_name.toLowerCase() === language.toLowerCase();
    });

    if (obj) return obj;else return null;
  } else {
    return null;
  }
}

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticationService = undefined;

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(160);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var secretKey = "HereIsTheMySecretKey_LOL";

var authenticationService = exports.authenticationService = {
  login: login,
  logout: logout
  // currentUser: currentUserSubject.asObservable(),
  // get currentUserValue() {
  //   return currentUserSubject.value;
  // },
};
// function set(key, value) {
//   if (key && value && String(key).length > 0 && String(value).length > 0) {
//     let setEncryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
//     window.localStorage.setItem(key, setEncryptedData);
//   } else {
//     console.error('key value is undefined');
//   }
// }

// function get(key) {
//   let getEncryptedData = window.localStorage.getItem(key);
//   if (!_.isNull(getEncryptedData))
//     return JSON.parse(CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(CryptoJS.enc.Utf8))
//   return null;
// }

function login(username, password) {
  // Call API
  // return Axios;
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("USINFO");
  // currentUserSubject.next(null);
}

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(255);

var _Api2 = _interopRequireDefault(_Api);

var _axios = __webpack_require__(91);

var _axios2 = _interopRequireDefault(_axios);

var _jquery = __webpack_require__(933);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  SendLog: function SendLog(payload) {
    return (0, _Api2.default)().post("/api/admin/insertlog", payload);
  },
  GetIpDetails: function GetIpDetails() {
    _jquery2.default.ajax({
      url: "https://ipapi.co/json",
      method: "GET"
    }).then(function (ressss) {
      console.log("objectobjectobjectobjectobjectobject :");
    });
  },
  SendNotificationLog: function SendNotificationLog(payload) {
    return (0, _Api2.default)().post("/api/admin/notificationlog", payload);
  },
  GetAllNotification: function GetAllNotification(payload) {
    return (0, _Api2.default)().get("/api/admin/notificationlog?user_id=" + payload.user_id + "&limit=" + payload.limit + "&currentPage=" + payload.currentPage);
  },
  UpdateNotificationStatus: function UpdateNotificationStatus(payload) {
    return (0, _Api2.default)().put("/api/admin/notificationlog", payload);
  }
};
// https://api.ipapi.com/check?access_key=229c548dcafb9cff13041d9544ac60af

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 940:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[618]);


// WEBPACK FOOTER //
// static/js/app.9bb6d70b6a4a22dd7069.js